export const global_marketlist = {
  "1": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Tip",
    "group": "all|score|regular_play"
  },
  "2": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "To qualify",
    "group": "all|score|cup_tie"
  },
  "3": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Which team will win the final",
    "group": "all|score|cup_tie"
  },
  "4": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Which team will win the 3rd place final",
    "group": "all|score|cup_tie"
  },
  "5": {
    "14": "{$competitor1} regular time",
    "15": "{$competitor2} regular time",
    "16": "{$competitor1} overtime",
    "17": "{$competitor2} overtime",
    "18": "{$competitor1} penalties",
    "19": "{$competitor2} penalties",
    "name": "Winning method",
    "group": "all|score|cup_tie"
  },
  "6": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Which team kicks off",
    "group": "all|misc"
  },
  "7": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Remaining match",
    "group": "all|score|regular_play"
  },
  "8": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!goalnr} goal",
    "group": "all|score|regular_play"
  },
  "9": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Last goal",
    "group": "all|score|regular_play"
  },
  "10": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "Double chance",
    "group": "all|score|regular_play"
  },
  "11": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Draw no bet",
    "group": "all|score|regular_play"
  },
  "12": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "{$competitor1} no bet",
    "group": "all|score|regular_play"
  },
  "13": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "{$competitor2} no bet",
    "group": "all|score|regular_play"
  },
  "14": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "16": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap",
    "group": "all|score|regular_play"
  },
  "18": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under",
    "group": "all|score|regular_play"
  },
  "19": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under",
    "group": "all|score|regular_play"
  },
  "20": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under",
    "group": "all|score|regular_play"
  },
  "26": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even",
    "group": "all|score|regular_play"
  },
  "27": {
    "70": "odd",
    "72": "even",
    "name": "{$competitor1} odd/even",
    "group": "all|score|regular_play"
  },
  "28": {
    "70": "odd",
    "72": "even",
    "name": "{$competitor2} odd/even",
    "group": "all|score|regular_play"
  },
  "29": {
    "74": "yes",
    "76": "no",
    "name": "Both teams to score",
    "group": "all|score|regular_play"
  },
  "30": {
    "784": "none",
    "788": "only {$competitor1}",
    "790": "only {$competitor2}",
    "792": "both teams",
    "name": "Which team to score",
    "group": "all|score|regular_play"
  },
  "31": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} clean sheet",
    "group": "all|score|regular_play"
  },
  "32": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} clean sheet",
    "group": "all|score|regular_play"
  },
  "33": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} win to nil",
    "group": "all|score|regular_play"
  },
  "34": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} win to nil",
    "group": "all|score|regular_play"
  },
  "35": {
    "78": "{$competitor1} & yes",
    "80": "{$competitor1} & no",
    "82": "X & yes",
    "84": "X & no",
    "86": "{$competitor2} & yes",
    "88": "{$competitor2} & no",
    "name": "1x2 & both teams to score",
    "group": "all|regular_play|combo"
  },
  "36": {
    "90": "over {total} & yes",
    "92": "under {total} & yes",
    "94": "over {total} & no",
    "96": "under {total} & no",
    "name": "Over/Under & both teams to score",
    "group": "all|regular_play|combo"
  },
  "37": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & Over/Under",
    "group": "all|regular_play|combo|incl_ot"
  },
  "38": {
    "1716": "no goal",
    "name": "{!goalnr} goalscorer",
    "group": "all|regular_play|scorers"
  },
  "39": {
    "1716": "no goal",
    "name": "Last goalscorer",
    "group": "all|regular_play|scorers"
  },
  "40": {
    "1716": "no goal",
    "name": "Anytime goalscorer",
    "group": "all|regular_play|scorers"
  },
  "41": {
    "110": "0:0",
    "114": "1:0",
    "116": "2:0",
    "118": "3:0",
    "120": "4:0",
    "122": "5:0",
    "124": "6:0",
    "126": "0:1",
    "128": "1:1",
    "130": "2:1",
    "132": "3:1",
    "134": "4:1",
    "136": "5:1",
    "138": "0:2",
    "140": "1:2",
    "142": "2:2",
    "144": "3:2",
    "146": "4:2",
    "148": "0:3",
    "150": "1:3",
    "152": "2:3",
    "154": "3:3",
    "156": "0:4",
    "158": "1:4",
    "160": "2:4",
    "162": "0:5",
    "164": "1:5",
    "166": "0:6",
    "name": "Correct score {!score}",
    "group": "all|score|regular_play"
  },
  "45": {
    "274": "0:0",
    "276": "1:0",
    "278": "2:0",
    "280": "3:0",
    "282": "4:0",
    "284": "0:1",
    "286": "1:1",
    "288": "2:1",
    "290": "3:1",
    "292": "4:1",
    "294": "0:2",
    "296": "1:2",
    "298": "2:2",
    "300": "3:2",
    "302": "4:2",
    "304": "0:3",
    "306": "1:3",
    "308": "2:3",
    "310": "3:3",
    "312": "4:3",
    "314": "0:4",
    "316": "1:4",
    "318": "2:4",
    "320": "3:4",
    "322": "4:4",
    "324": "other",
    "name": "Correct score",
    "group": "all|score|regular_play"
  },
  "46": {
    "326": "0:0 0:0",
    "328": "0:0 0:1",
    "330": "0:0 0:2",
    "332": "0:0 0:3",
    "334": "0:0 1:0",
    "336": "0:0 1:1",
    "338": "0:0 1:2",
    "340": "0:0 2:0",
    "342": "0:0 2:1",
    "344": "0:0 3:0",
    "346": "0:0 4+",
    "348": "0:1 0:1",
    "350": "0:1 0:2",
    "352": "0:1 0:3",
    "354": "0:1 1:1",
    "356": "0:1 1:2",
    "358": "0:1 2:1",
    "360": "0:1 4+",
    "362": "0:2 0:2",
    "364": "0:2 0:3",
    "366": "0:2 1:2",
    "368": "0:2 4+",
    "370": "0:3 0:3",
    "372": "0:3 4+",
    "374": "1:0 1:0",
    "376": "1:0 1:1",
    "378": "1:0 1:2",
    "380": "1:0 2:0",
    "382": "1:0 2:1",
    "384": "1:0 3:0",
    "386": "1:0 4+",
    "388": "1:1 1:1",
    "390": "1:1 1:2",
    "392": "1:1 2:1",
    "394": "1:1 4+",
    "396": "1:2 1:2",
    "398": "1:2 4+",
    "400": "2:0 2:0",
    "402": "2:0 2:1",
    "404": "2:0 3:0",
    "406": "2:0 4+",
    "408": "2:1 2:1",
    "410": "2:1 4+",
    "412": "3:0 3:0",
    "414": "3:0 4+",
    "416": "4+ 4+",
    "name": "HT/fulltime correct score",
    "group": "all|score|regular_play"
  },
  "47": {
    "418": "{$competitor1}/{$competitor1}",
    "420": "{$competitor1}/X",
    "422": "{$competitor1}/{$competitor2}",
    "424": "X/{$competitor1}",
    "426": "X/X",
    "428": "X/{$competitor2}",
    "430": "{$competitor2}/{$competitor1}",
    "432": "{$competitor2}/X",
    "434": "{$competitor2}/{$competitor2}",
    "name": "HT/fulltime",
    "group": "all|score|regular_play"
  },
  "48": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win both HT",
    "group": "all|score|regular_play"
  },
  "49": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win both HT",
    "group": "all|score|regular_play"
  },
  "50": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win either half",
    "group": "all|score|regular_play"
  },
  "51": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win either half",
    "group": "all|score|regular_play"
  },
  "52": {
    "436": "1st HT",
    "438": "2nd HT",
    "440": "equal",
    "name": "Highest scoring half",
    "group": "all|score|regular_play"
  },
  "53": {
    "436": "1st HT",
    "438": "2nd HT",
    "440": "equal",
    "name": "{$competitor1} highest scoring half",
    "group": "all|score|regular_play"
  },
  "54": {
    "436": "1st HT",
    "438": "2nd HT",
    "440": "equal",
    "name": "{$competitor2} highest scoring half",
    "group": "all|score|regular_play"
  },
  "55": {
    "806": "no/no",
    "808": "yes/no",
    "810": "yes/yes",
    "812": "no/yes",
    "name": "1st/2nd HT both teams to score",
    "group": "all|score|regular_play"
  },
  "56": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to score in both HT",
    "group": "all|score|regular_play"
  },
  "57": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to score in both HT",
    "group": "all|score|regular_play"
  },
  "58": {
    "74": "yes",
    "76": "no",
    "name": "Both HT over {total}",
    "group": "all|score|regular_play"
  },
  "59": {
    "74": "yes",
    "76": "no",
    "name": "Both HT under {total}",
    "group": "all|score|regular_play"
  },
  "60": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT - 1x2",
    "group": "all|score|1st_half"
  },
  "61": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT - Remaining Match",
    "group": "all|score|1st_half"
  },
  "62": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - {!goalnr} goal",
    "group": "all|score|1st_half"
  },
  "63": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "1st HT - double chance",
    "group": "all|score|1st_half"
  },
  "64": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st HT - draw no bet",
    "group": "all|score|1st_half"
  },
  "65": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1st HT - handicap {hcp}",
    "group": "all|score|1st_half"
  },
  "66": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1st HT - handicap",
    "group": "all|score|1st_half"
  },
  "68": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - Over/Under",
    "group": "all|score|1st_half"
  },
  "69": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor1} Over/Under",
    "group": "all|score|1st_half"
  },
  "70": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor2} Over/Under",
    "group": "all|score|1st_half"
  },
  "74": {
    "70": "odd",
    "72": "even",
    "name": "1st HT - odd/even",
    "group": "all|score|1st_half"
  },
  "75": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - both teams to score",
    "group": "all|score|1st_half"
  },
  "76": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - {$competitor1} clean sheet",
    "group": "all|score|1st_half"
  },
  "77": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - {$competitor2} clean sheet",
    "group": "all|score|1st_half"
  },
  "78": {
    "78": "{$competitor1} & yes",
    "80": "{$competitor1} & no",
    "82": "X & yes",
    "84": "X & no",
    "86": "{$competitor2} & yes",
    "88": "{$competitor2} & no",
    "name": "1st HT - 1x2 & both teams to score",
    "group": "all|combo|1st_half"
  },
  "79": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "1st HT - 1x2 & Over/Under",
    "group": "all|combo|1st_half"
  },
  "80": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "1st HT - correct score {!score}",
    "group": "all|score|1st_half"
  },
  "81": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "other",
    "name": "1st HT - correct score",
    "group": "all|score|1st_half"
  },
  "83": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2nd HT - 1x2",
    "group": "all|score|2nd_half"
  },
  "84": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "2nd HT - {!goalnr} goal",
    "group": "all|score|2nd_half"
  },
  "85": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "2nd HT - double chance",
    "group": "all|score|2nd_half"
  },
  "86": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd HT - draw no bet",
    "group": "all|score|2nd_half"
  },
  "87": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "2nd HT - handicap {hcp}",
    "group": "all|score|2nd_half"
  },
  "88": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2nd HT - handicap",
    "group": "all|score|2nd_half"
  },
  "90": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "2nd HT - Over/Under",
    "group": "all|score|2nd_half"
  },
  "91": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "2nd HT - {$competitor1} Over/Under",
    "group": "all|score|2nd_half"
  },
  "92": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "2nd HT - {$competitor2} Over/Under",
    "group": "all|score|2nd_half"
  },
  "94": {
    "70": "odd",
    "72": "even",
    "name": "2nd HT - odd/even",
    "group": "all|score|2nd_half"
  },
  "95": {
    "74": "yes",
    "76": "no",
    "name": "2nd HT - both teams to score",
    "group": "all|score|2nd_half"
  },
  "96": {
    "74": "yes",
    "76": "no",
    "name": "2nd HT - {$competitor1} clean sheet",
    "group": "all|score|2nd_half"
  },
  "97": {
    "74": "yes",
    "76": "no",
    "name": "2nd HT - {$competitor2} clean sheet",
    "group": "all|score|2nd_half"
  },
  "98": {
    "546": "0:0",
    "548": "0:1",
    "550": "0:2",
    "552": "1:0",
    "554": "1:1",
    "556": "1:2",
    "558": "2:0",
    "560": "2:1",
    "562": "2:2",
    "564": "other",
    "name": "2nd HT - correct score",
    "group": "all|score|2nd_half"
  },
  "100": {
    "584": "1-15",
    "586": "16-30",
    "588": "31-45",
    "590": "46-60",
    "592": "61-75",
    "594": "76-90",
    "596": "none",
    "name": "When will the {!goalnr} goal be scored (15 min interval)",
    "group": "all|score|regular_play"
  },
  "101": {
    "598": "1-10",
    "600": "11-20",
    "602": "21-30",
    "604": "31-40",
    "606": "41-50",
    "608": "51-60",
    "610": "61-70",
    "612": "71-80",
    "614": "81-90",
    "616": "none",
    "name": "When will the {!goalnr} goal be scored (10 min interval)",
    "group": "all|score|regular_play"
  },
  "102": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minutes - 1x2 from {from} to {to}",
    "group": "all|score|15_min"
  },
  "103": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "15 minutes - {!goalnr} goal from {from} to {to}",
    "group": "all|score|15_min"
  },
  "104": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "15 minutes - Over/Under from {from} to {to}",
    "group": "all|score|15_min"
  },
  "105": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minutes - 1x2 from {from} to {to}",
    "group": "all|score|10_min"
  },
  "106": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "10 minutes - {!goalnr} goal from {from} to {to}",
    "group": "all|score|10_min"
  },
  "107": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "10 minutes - Over/Under from {from} to {to}",
    "group": "all|score|10_min"
  },
  "108": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minutes - 1x2 from {from} to {to}",
    "group": "all|score|5_min"
  },
  "109": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "5 minutes - {!goalnr} goal from {from} to {to}",
    "group": "all|score|5_min"
  },
  "110": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "5 minutes - Over/Under from {from} to {to}",
    "group": "all|score|5_min"
  },
  "112": {
    "74": "yes",
    "76": "no",
    "name": "Overtime & goal",
    "group": "all|combo|ot"
  },
  "113": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Overtime - 1x2",
    "group": "all|score|ot"
  },
  "114": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Overtime - which team wins the rest",
    "group": "all|score|ot"
  },
  "115": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Overtime - {!goalnr} goal",
    "group": "all|score|ot"
  },
  "116": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Overtime - Over/Under",
    "group": "all|score|ot"
  },
  "117": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Overtime - handicap",
    "group": "all|score|ot"
  },
  "118": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "Overtime - correct score {!score}",
    "group": "all|score|ot"
  },
  "119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Overtime 1st HT - 1x2",
    "group": "all|score|ot_1st_half"
  },
  "120": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Overtime 1st HT - handicap",
    "group": "all|score|ot_1st_half"
  },
  "121": {
    "618": "0:0",
    "620": "1:0",
    "622": "2:0",
    "624": "0:1",
    "626": "1:1",
    "628": "0:2",
    "name": "Overtime 1st HT - correct score {!score}",
    "group": "all|score|ot_1st_half"
  },
  "122": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a penalty shootout",
    "group": "all|score|incl_ot"
  },
  "123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Penalty shootout - winner",
    "group": "all|score|pen_so"
  },
  "124": {
    "74": "yes",
    "76": "no",
    "name": "Penalty shootout - {!penaltynr} penalty scored",
    "group": "all|score|pen_so"
  },
  "125": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Penalty shootout - {!goalnr} goal",
    "group": "all|score|pen_so"
  },
  "126": {
    "630": "{$competitor1} by 1",
    "632": "{$competitor1} by 2",
    "634": "{$competitor1} by 3+",
    "636": "{$competitor2} by 1",
    "638": "{$competitor2} by 2",
    "640": "{$competitor2} by 3+",
    "name": "Penalty shootout - winning margin",
    "group": "all|score|pen_so"
  },
  "127": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Penalty shootout - Over/Under",
    "group": "all|score|pen_so"
  },
  "128": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Penalty shootout - {$competitor1} Over/Under",
    "group": "all|score|pen_so"
  },
  "129": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Penalty shootout - {$competitor2} Over/Under",
    "group": "all|score|pen_so"
  },
  "131": {
    "70": "odd",
    "72": "even",
    "name": "Penalty shootout - odd/even",
    "group": "all|score|pen_so"
  },
  "132": {
    "70": "odd",
    "72": "even",
    "name": "Penalty shootout - {$competitor1} odd/even",
    "group": "all|score|pen_so"
  },
  "133": {
    "70": "odd",
    "72": "even",
    "name": "Penalty shootout - {$competitor2} odd/even",
    "group": "all|score|pen_so"
  },
  "134": {
    "656": "{$competitor1} & under {total}",
    "658": "{$competitor2} & under {total}",
    "660": "{$competitor1} & over {total}",
    "662": "{$competitor2} & over {total}",
    "name": "Penalty shootout - winner & Over/Under",
    "group": "all|combo|pen_so"
  },
  "135": {
    "1767": "0:1",
    "1768": "0:2",
    "1769": "0:3",
    "1770": "1:0",
    "1771": "1:2",
    "1772": "1:3",
    "1773": "1:4",
    "1774": "2:0",
    "1775": "2:1",
    "1776": "2:3",
    "1777": "2:4",
    "1778": "3:0",
    "1779": "3:1",
    "1780": "3:2",
    "1781": "3:4",
    "1782": "3:5",
    "1783": "4:1",
    "1784": "4:2",
    "1785": "4:3",
    "1786": "4:5",
    "1787": "5:3",
    "1788": "5:4",
    "1789": "other",
    "name": "Penalty shootout - correct score",
    "group": "all|score|pen_so"
  },
  "136": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Booking 1x2",
    "group": "all|regular_play|bookings"
  },
  "137": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!bookingnr} booking",
    "group": "all|regular_play|bookings"
  },
  "138": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under booking points",
    "group": "all|regular_play|bookings"
  },
  "139": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under bookings",
    "group": "all|regular_play|bookings"
  },
  "140": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under bookings",
    "group": "all|regular_play|bookings"
  },
  "141": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under bookings",
    "group": "all|regular_play|bookings"
  },
  "142": {
    "710": "0-3",
    "712": "4",
    "714": "5",
    "716": "6",
    "718": "7",
    "720": "8",
    "722": "9",
    "724": "10",
    "726": "11",
    "728": "12+",
    "name": "Exact bookings",
    "group": "all|regular_play|bookings"
  },
  "143": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor1} exact bookings",
    "group": "all|regular_play|bookings"
  },
  "144": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor2} exact bookings",
    "group": "all|regular_play|bookings"
  },
  "146": {
    "74": "yes",
    "76": "no",
    "name": "Sending off",
    "group": "all|regular_play|bookings"
  },
  "147": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} sending off",
    "group": "all|regular_play|bookings"
  },
  "148": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} sending off",
    "group": "all|regular_play|bookings"
  },
  "149": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT - booking 1x2",
    "group": "all|1st_half|bookings"
  },
  "150": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - {!bookingnr} booking",
    "group": "all|1st_half|bookings"
  },
  "151": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - Over/Under booking points",
    "group": "all|1st_half|bookings"
  },
  "152": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - Over/Under bookings",
    "group": "all|1st_half|bookings"
  },
  "153": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor1} Over/Under bookings",
    "group": "all|1st_half|bookings"
  },
  "154": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor2} Over/Under bookings",
    "group": "all|1st_half|bookings"
  },
  "155": {
    "1760": "0",
    "1761": "1",
    "1762": "2",
    "1763": "3",
    "1764": "4",
    "1765": "5",
    "1766": "6+",
    "name": "1st HT - exact bookings",
    "group": "all|1st_half|bookings"
  },
  "156": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1st HT - {$competitor1} exact bookings",
    "group": "all|1st_half|bookings"
  },
  "157": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1st HT - {$competitor2} exact bookings",
    "group": "all|1st_half|bookings"
  },
  "159": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - sending off",
    "group": "all|1st_half|bookings"
  },
  "160": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - {$competitor1} sending off",
    "group": "all|1st_half|bookings"
  },
  "161": {
    "74": "yes",
    "76": "no",
    "name": "1st HT - {$competitor2} sending off",
    "group": "all|1st_half|bookings"
  },
  "162": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Corner 1x2",
    "group": "all|regular_play|corners"
  },
  "163": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!cornernr} corner",
    "group": "all|regular_play|corners"
  },
  "164": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Last corner",
    "group": "all|regular_play|corners"
  },
  "165": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Corner handicap",
    "group": "all|regular_play|corners"
  },
  "166": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under corners",
    "group": "all|regular_play|corners"
  },
  "167": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under corners",
    "group": "all|regular_play|corners"
  },
  "168": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under corners",
    "group": "all|regular_play|corners"
  },
  "172": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even corners",
    "group": "all|regular_play|corners"
  },
  "173": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT - corner 1x2",
    "group": "all|1st_half|corners"
  },
  "174": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - {!cornernr} corner",
    "group": "all|1st_half|corners"
  },
  "175": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - last corner",
    "group": "all|1st_half|corners"
  },
  "176": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1st HT - corner handicap",
    "group": "all|1st_half|corners"
  },
  "177": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - Over/Under corners",
    "group": "all|1st_half|corners"
  },
  "178": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor1} Over/Under corners",
    "group": "all|1st_half|corners"
  },
  "179": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor2} Over/Under corners",
    "group": "all|1st_half|corners"
  },
  "180": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1st HT - {$competitor1} exact corners",
    "group": "all|1st_half|corners"
  },
  "181": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1st HT - {$competitor2} exact corners",
    "group": "all|1st_half|corners"
  },
  "183": {
    "70": "odd",
    "72": "even",
    "name": "1st HT - odd/even corners",
    "group": "all|1st_half|corners"
  },
  "184": {
    "814": "{$competitor1} goal & {$competitor1}",
    "816": "{$competitor1} goal & X",
    "818": "{$competitor1} goal & {$competitor2}",
    "820": "{$competitor2} goal & {$competitor1}",
    "822": "{$competitor2} goal & X",
    "824": "{$competitor2} goal & {$competitor2}",
    "826": "no goal",
    "name": "{!goalnr} goal & 1x2",
    "group": "all|regular_play|combo"
  },
  "186": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winner",
    "group": "all|score|regular_play"
  },
  "187": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Game handicap",
    "group": "all|score|regular_play"
  },
  "188": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Set handicap",
    "group": "all|score|regular_play"
  },
  "189": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under games",
    "group": "all|score|regular_play"
  },
  "190": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under games",
    "group": "all|score|regular_play"
  },
  "191": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under games",
    "group": "all|score|regular_play"
  },
  "192": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win a set",
    "group": "all|score|regular_play"
  },
  "193": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win a set",
    "group": "all|score|regular_play"
  },
  "194": {
    "74": "yes",
    "76": "no",
    "name": "Any set to nil",
    "group": "all|score|regular_play"
  },
  "195": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a tiebreak",
    "group": "all|score|regular_play"
  },
  "198": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even games",
    "group": "all|score|regular_play"
  },
  "201": {
    "861": "{$competitor1}/{$competitor1}",
    "862": "{$competitor2}/{$competitor1}",
    "863": "{$competitor1}/{$competitor2}",
    "864": "{$competitor2}/{$competitor2}",
    "name": "Double result (1st set/match)",
    "group": "all|score|regular_play"
  },
  "202": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - winner",
    "group": "all|score|set"
  },
  "203": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - game handicap",
    "group": "all|score|set"
  },
  "204": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - Over/Under games",
    "group": "all|score|set"
  },
  "205": {
    "70": "odd",
    "72": "even",
    "name": "{!setnr} set - odd/even games",
    "group": "all|score|set"
  },
  "206": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set - will there be a tiebreak",
    "group": "all|score|set"
  },
  "207": {
    "865": "6:0",
    "866": "6:1",
    "867": "6:2",
    "868": "6:3",
    "869": "6:4",
    "870": "7:5",
    "871": "7:6",
    "872": "0:6",
    "873": "1:6",
    "874": "2:6",
    "875": "3:6",
    "876": "4:6",
    "877": "5:7",
    "878": "6:7",
    "name": "{!setnr} set - correct score",
    "group": "all|score|set"
  },
  "208": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - race to {games} games",
    "group": "all|score|set"
  },
  "209": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - {!gamenrX} and {!gamenrY} game winner",
    "group": "all|score|game"
  },
  "210": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set game {gamenr} - winner",
    "group": "all|score|game"
  },
  "211": {
    "882": "4",
    "883": "5",
    "884": "6",
    "885": "7+",
    "name": "{!setnr} set game {gamenr} - exact points",
    "group": "all|score|game"
  },
  "212": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set game {gamenr} - to deuce",
    "group": "all|score|game"
  },
  "213": {
    "70": "odd",
    "72": "even",
    "name": "{!setnr} set game {gamenr} - odd/even points",
    "group": "all|score|game"
  },
  "214": {
    "886": "{$competitor1} to 0",
    "887": "{$competitor1} to 15",
    "888": "{$competitor1} to 30",
    "889": "{$competitor1} to 40",
    "890": "{$competitor2} to 0",
    "891": "{$competitor2} to 15",
    "892": "{$competitor2} to 30",
    "893": "{$competitor2} to 40",
    "name": "{!setnr} set game {gamenr} - correct score",
    "group": "all|score|game"
  },
  "215": {
    "894": "{%server} to 0",
    "895": "{%server} to 15",
    "896": "{%server} to 30",
    "897": "{%server} to 40",
    "898": "break",
    "name": "{!setnr} set game {gamenr} - correct score or break",
    "group": "all|score|game"
  },
  "216": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set game {gamenr} - race to {pointnr} points",
    "group": "all|score|points"
  },
  "217": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set game {gamenr} - first {pointnr} points winner",
    "group": "all|score|points"
  },
  "218": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point",
    "group": "all|score|points"
  },
  "219": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winner (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "220": {
    "74": "yes",
    "76": "no",
    "name": "Will there be overtime",
    "group": "all|score|regular_play"
  },
  "221": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!scorenr} score (incl. overtime)",
    "group": "all"
  },
  "222": {
    "901": "touchdown",
    "902": "fieldgoal",
    "903": "other",
    "904": "none",
    "name": "{!scorenr} scoring type (incl. overtime)",
    "group": "all"
  },
  "223": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "224": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "225": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "226": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "US Over/Under (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "227": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "228": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "229": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "230": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to {pointnr} points (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "231": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2nd HT - handicap (incl. overtime)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "232": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "2nd HT - Over/Under (incl. overtime)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "234": {
    "920": "1st quarter",
    "921": "2nd quarter",
    "922": "3rd quarter",
    "923": "4th quarter",
    "924": "equal",
    "name": "Highest scoring quarter",
    "group": "all|score|regular_play"
  },
  "235": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} quarter - 1x2",
    "group": "all|score|quarter"
  },
  "236": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!quarternr} quarter - Over/Under",
    "group": "all|score|quarter"
  },
  "237": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Point handicap",
    "group": "all|score|regular_play"
  },
  "238": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under points",
    "group": "all|score|regular_play"
  },
  "245": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} game - winner",
    "group": "all|score|game"
  },
  "246": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!gamenr} game - point handicap",
    "group": "all|score|game"
  },
  "247": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!gamenr} game - Over/Under points",
    "group": "all|score|game"
  },
  "248": {
    "70": "odd",
    "72": "even",
    "name": "{!gamenr} game - odd/even",
    "group": "all|score|game"
  },
  "250": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} game - race to {pointnr} points",
    "group": "all|score|game"
  },
  "251": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winner (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "252": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (incl. extra innings)",
    "group": "all"
  },
  "253": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Which team wins the rest of the match (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "254": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "255": {
    "630": "{$competitor1} by 1",
    "632": "{$competitor1} by 2",
    "634": "{$competitor1} by 3+",
    "636": "{$competitor2} by 1",
    "638": "{$competitor2} by 2",
    "640": "{$competitor2} by 3+",
    "name": "Winning margin (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "256": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "257": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US Spread (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "258": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "259": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "US Over/Under (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "260": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "261": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "262": {
    "939": "under {total}",
    "940": "exact {total}",
    "941": "over {total}",
    "name": "Over/Under (over-exact-under) (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "264": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "265": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "1x2 & Over/Under (incl. extra innings)",
    "group": "all|combo|incl_ei"
  },
  "266": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!runnr} run (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "267": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to {runnr} runs (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "268": {
    "74": "yes",
    "76": "no",
    "name": "Will there be an extra inning",
    "group": "all|score|regular_play"
  },
  "269": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to bat in 9th inning",
    "group": "all|score|regular_play"
  },
  "270": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Team to win more innings",
    "group": "all|score|regular_play"
  },
  "271": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "Team with highest scoring inning",
    "group": "all|score|regular_play"
  },
  "272": {
    "951": "1st inning",
    "952": "2nd inning",
    "953": "3rd inning",
    "954": "4th inning",
    "955": "5th inning",
    "956": "6th inning",
    "957": "7th inning",
    "958": "8th inning",
    "959": "9th inning",
    "960": "equal",
    "name": "Highest scoring inning",
    "group": "all|score|regular_play"
  },
  "273": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Exact runs in highest scoring inning",
    "group": "all|score|regular_play"
  },
  "274": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings 1 to 5 - 1x2",
    "group": "all|score|5_innings"
  },
  "275": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings 1 to 5 - handicap",
    "group": "all|score|5_innings"
  },
  "276": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - Over/Under",
    "group": "all|score|5_innings"
  },
  "277": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - {$competitor1} Over/Under",
    "group": "all|score|5_innings"
  },
  "278": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - {$competitor2} Over/Under",
    "group": "all|score|5_innings"
  },
  "279": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings 1 to 5th top - 1x2",
    "group": "all|score|4.5_innings"
  },
  "280": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings 1 to 5th top - handicap",
    "group": "all|score|4.5_innings"
  },
  "281": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5th top - Over/Under",
    "group": "all|score|4.5_innings"
  },
  "282": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5th top - {$competitor1} Over/Under",
    "group": "all|score|4.5_innings"
  },
  "283": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5th top - {$competitor2} Over/Under",
    "group": "all|score|4.5_innings"
  },
  "284": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings {from} to {to} - Over/Under",
    "group": "all|score|3_innings"
  },
  "285": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings {from} to {to} - {$competitor1} Over/Under",
    "group": "all|score|3_innings"
  },
  "286": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings {from} to {to} - {$competitor2} Over/Under",
    "group": "all|score|3_innings"
  },
  "287": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - 1x2",
    "group": "all|score|inning"
  },
  "288": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - Over/Under",
    "group": "all|score|inning"
  },
  "289": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Which team wins the jump ball",
    "group": "all|misc"
  },
  "291": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!pointnr} point (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "292": {
    "973": "{$competitor1} & over {total}",
    "974": "{$competitor2} & over {total}",
    "975": "{$competitor1} & under {total}",
    "976": "{$competitor2} & under {total}",
    "name": "Winner & Over/Under (incl. overtime)",
    "group": "all|combo|incl_ot"
  },
  "293": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "2nd HT - 1x2 (incl. overtime)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "294": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd HT - draw no bet (incl. overtime)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "295": {
    "70": "odd",
    "72": "even",
    "name": "2nd HT - odd/even (incl. overtime)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "297": {
    "939": "under {total}",
    "940": "exact {total}",
    "941": "over {total}",
    "name": "Over/Under (over-exact-under)",
    "group": "all|score|regular_play"
  },
  "300": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to {pointnr} points",
    "group": "all|score|regular_play"
  },
  "301": {
    "1002": "{$competitor1} by 3+",
    "1003": "{$competitor2} by 3+",
    "1004": "other",
    "name": "{!quarternr} quarter - winning margin",
    "group": "all|score|quarter"
  },
  "302": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - draw no bet",
    "group": "all|score|quarter"
  },
  "303": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} quarter - handicap",
    "group": "all|score|quarter"
  },
  "304": {
    "70": "odd",
    "72": "even",
    "name": "{!quarternr} quarter - odd/even",
    "group": "all|score|quarter"
  },
  "305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - race to {pointnr} points",
    "group": "all|score|quarter"
  },
  "309": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - point handicap",
    "group": "all|score|set"
  },
  "310": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - Over/Under points",
    "group": "all|score|set"
  },
  "311": {
    "70": "odd",
    "72": "even",
    "name": "{!setnr} set - odd/even",
    "group": "all|score|set"
  },
  "312": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - {!pointnr} point",
    "group": "all|score|set"
  },
  "313": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - race to {pointnr} points",
    "group": "all|score|set"
  },
  "314": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under sets",
    "group": "all|score|regular_play"
  },
  "315": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - 1x2",
    "group": "all|score|set"
  },
  "316": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - draw no bet",
    "group": "all|score|set"
  },
  "317": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!setnr} set - handicap {hcp}",
    "group": "all|score|set"
  },
  "318": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor1} Over/Under",
    "group": "all|score|set"
  },
  "319": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor2} Over/Under",
    "group": "all|score|set"
  },
  "322": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set end {endnr} - winner",
    "group": "all|score|end"
  },
  "323": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set end {endnr} - Over/Under",
    "group": "all|score|end"
  },
  "324": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "{!setnr} set end {endnr} - exact points",
    "group": "all|score|end"
  },
  "325": {
    "70": "odd",
    "72": "even",
    "name": "{!setnr} set end {endnr} - odd/even",
    "group": "all|score|end"
  },
  "326": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Map handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "327": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Map handicap",
    "group": "all|score|regular_play"
  },
  "328": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under maps",
    "group": "all|score|regular_play"
  },
  "330": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - winner (incl. overtime)",
    "group": "all|score|map_incl_ot"
  },
  "331": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - round handicap (incl. overtime)",
    "group": "all|score|map_incl_ot"
  },
  "332": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map - Over/Under rounds (incl. overtime)",
    "group": "all|score|map_incl_ot"
  },
  "333": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} kill",
    "group": "all|kills|map"
  },
  "334": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!mapnr} map - 1x2",
    "group": "all|score|map"
  },
  "335": {
    "74": "yes",
    "76": "no",
    "name": "{!mapnr} map - will there be overtime",
    "group": "all|score|map"
  },
  "337": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map knife round - winner",
    "group": "all|round"
  },
  "338": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map round {roundnr} - winner",
    "group": "all|round"
  },
  "340": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winner (incl. super over)",
    "group": "all|score|incl_so"
  },
  "341": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a super over",
    "group": "all|score|regular_play"
  },
  "342": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a tie",
    "group": "all|score|regular_play"
  },
  "343": {
    "1031": "caught",
    "1032": "bowled",
    "1033": "lbw",
    "1034": "run out",
    "1035": "stumped",
    "1036": "others",
    "name": "{!inningnr} innings - {!dismissalnr} dismissal method",
    "group": "all|dismissal|innings"
  },
  "344": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{!inningnr} innings - {!dismissalnr} dismissal method (limited)",
    "group": "all|dismissal|innings"
  },
  "347": {
    "948": "{$competitor1}",
    "949": "X",
    "950": "{$competitor2}",
    "name": "{!inningnr} innings - team with highest scoring over",
    "group": "all|score|innings"
  },
  "349": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under at {!dismissalnr} dismissal",
    "group": "all|score|innings"
  },
  "350": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under at {!dismissalnr} dismissal",
    "group": "all|score|innings"
  },
  "351": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} innings overs 0 to {overnr} - 1x2",
    "group": "all|score|x_overs"
  },
  "352": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Over/Under",
    "group": "all|score|x_overs"
  },
  "353": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Over/Under",
    "group": "all|score|x_overs"
  },
  "356": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} Over/Under",
    "group": "all|score|over"
  },
  "357": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} Over/Under",
    "group": "all|score|over"
  },
  "358": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st over - Over/Under",
    "group": "all|score|over"
  },
  "359": {
    "70": "odd",
    "72": "even",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} odd/even",
    "group": "all|score|over"
  },
  "360": {
    "70": "odd",
    "72": "even",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} odd/even",
    "group": "all|score|over"
  },
  "361": {
    "70": "odd",
    "72": "even",
    "name": "1st over - odd/even",
    "group": "all|score|over"
  },
  "362": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} Over/Under",
    "group": "all|score|delivery"
  },
  "363": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} Over/Under",
    "group": "all|score|delivery"
  },
  "365": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Set handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "366": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Leg handicap",
    "group": "all|score|regular_play"
  },
  "367": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under legs",
    "group": "all|score|regular_play"
  },
  "368": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even sets",
    "group": "all|score|regular_play"
  },
  "370": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - which player wins the rest",
    "group": "all|score|set"
  },
  "371": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - leg handicap",
    "group": "all|score|set"
  },
  "372": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - Over/Under legs",
    "group": "all|score|set"
  },
  "373": {
    "70": "odd",
    "72": "even",
    "name": "{!setnr} set - odd/even legs",
    "group": "all|score|set"
  },
  "375": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set leg {legnr} - winner",
    "group": "all|score|leg"
  },
  "376": {
    "1039": "over {total}",
    "1040": "under {total}",
    "name": "{!setnr} set leg {legnr} - Over/Under darts",
    "group": "all|score|leg"
  },
  "377": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr} set leg {legnr} - highest scoring player on {!visitnr} visits",
    "group": "all|score|visit"
  },
  "378": {
    "1044": "0-89",
    "1045": "90-100",
    "1046": "101+",
    "name": "{!setnr} set leg {legnr} - point range on {!visitnr} visit",
    "group": "all|score|visit"
  },
  "379": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set leg {legnr} - checkout score {score}+",
    "group": "all|leg|checkout"
  },
  "380": {
    "1049": "red",
    "1050": "green",
    "name": "{!setnr} set leg {legnr} - checkout colour",
    "group": "all|leg|checkout"
  },
  "381": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "Most 180s",
    "group": "all|regular_play|180s"
  },
  "382": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!xth} player to score a 180",
    "group": "all|regular_play|180s"
  },
  "383": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "180s handicap",
    "group": "all|regular_play|180s"
  },
  "384": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under 180s",
    "group": "all|regular_play|180s"
  },
  "385": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under 180s",
    "group": "all|regular_play|180s"
  },
  "386": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under 180s",
    "group": "all|regular_play|180s"
  },
  "387": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "X",
    "name": "{!setnr} set - most 180s",
    "group": "all|set|180s"
  },
  "388": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - Over/Under 180s",
    "group": "all|set|180s"
  },
  "389": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor1} Over/Under 180s",
    "group": "all|set|180s"
  },
  "390": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor2} Over/Under 180s",
    "group": "all|set|180s"
  },
  "391": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set leg {legnr} - any player to score a 180",
    "group": "all|leg|180s"
  },
  "392": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set leg {legnr} - {$competitor1} to score a 180",
    "group": "all|leg|180s"
  },
  "393": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set leg {legnr} - {$competitor2} to score a 180",
    "group": "all|leg|180s"
  },
  "395": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - winner",
    "group": "all|map"
  },
  "396": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} aegis",
    "group": "all|map|structures"
  },
  "397": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} tower",
    "group": "all|map|structures"
  },
  "398": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} barracks",
    "group": "all|map|structures"
  },
  "401": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Correct score {!score}",
    "group": "all|score|regular_play"
  },
  "402": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "1st HT - correct score {!score}",
    "group": "all|score|1st_half"
  },
  "404": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!goalnr} goal (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "405": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to {goalnr} goals (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "406": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Winner (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "407": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!goalnr} goal (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "408": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "409": {
    "630": "{$competitor1} by 1",
    "632": "{$competitor1} by 2",
    "634": "{$competitor1} by 3+",
    "636": "{$competitor2} by 1",
    "638": "{$competitor2} by 2",
    "640": "{$competitor2} by 3+",
    "name": "Winning margin (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "410": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "411": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "US spread (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "412": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "413": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "US Over/Under (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "414": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "415": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "419": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "420": {
    "1475": "both",
    "1476": "only {$competitor1}",
    "1477": "only {$competitor2}",
    "name": "Which team to score (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "421": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} clean sheet (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "422": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} clean sheet (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "423": {
    "1478": "{$competitor1} goal & {$competitor1}",
    "1479": "{$competitor1} goal & {$competitor2}",
    "1480": "{$competitor2} goal & {$competitor1}",
    "1481": "{$competitor2} goal & {$competitor2}",
    "name": "{!goalnr} goal & winner (incl. overtime and penalties)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "424": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "1x2 & Over/Under (incl. overtime and penalties)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "425": {
    "1706": "{$competitor1} & yes",
    "1708": "{$competitor1} & no",
    "1709": "{$competitor2} & yes",
    "1710": "{$competitor2} & no",
    "name": "1x2 & both teams to score (incl. overtime and penalties)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "426": {
    "1482": "{$competitor1} & {$competitor1}",
    "1483": "X & {$competitor1}",
    "1484": "{$competitor2} & {$competitor1}",
    "1485": "{$competitor1} & {$competitor2}",
    "1486": "X & {$competitor2}",
    "1487": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} period 1x2 & winner (incl. overtime and penalties)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "427": {
    "1488": "1:0",
    "1489": "2:0",
    "1490": "3:0",
    "1491": "4:0",
    "1492": "5:0",
    "1493": "0:1",
    "1494": "2:1",
    "1495": "3:1",
    "1496": "4:1",
    "1497": "5:1",
    "1498": "0:2",
    "1499": "1:2",
    "1500": "3:2",
    "1501": "4:2",
    "1502": "5:2",
    "1503": "0:3",
    "1504": "1:3",
    "1505": "2:3",
    "1506": "4:3",
    "1507": "5:3",
    "1508": "0:4",
    "1509": "1:4",
    "1510": "2:4",
    "1511": "3:4",
    "1512": "5:4",
    "1513": "0:5",
    "1514": "1:5",
    "1515": "2:5",
    "1516": "3:5",
    "1517": "4:5",
    "1518": "other",
    "name": "Correct score (incl. overtime and penalties)",
    "group": "all|score|incl_ot_and_pen"
  },
  "429": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & X",
    "1533": "X & X",
    "1534": "{$competitor2} & X",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} period 1x2 & 1x2",
    "group": "all|regular_play|combo"
  },
  "430": {
    "1538": "0:0",
    "1539": "1:0",
    "1540": "2:0",
    "1541": "3:0",
    "1542": "4:0",
    "1543": "5:0",
    "1544": "6:0",
    "1545": "7:0",
    "1546": "8:0",
    "1547": "0:1",
    "1548": "1:1",
    "1549": "2:1",
    "1550": "3:1",
    "1551": "4:1",
    "1552": "5:1",
    "1553": "6:1",
    "1554": "7:1",
    "1555": "0:2",
    "1556": "1:2",
    "1557": "2:2",
    "1558": "3:2",
    "1559": "4:2",
    "1560": "5:2",
    "1561": "6:2",
    "1562": "0:3",
    "1563": "1:3",
    "1564": "2:3",
    "1565": "3:3",
    "1566": "4:3",
    "1567": "5:3",
    "1568": "0:4",
    "1569": "1:4",
    "1570": "2:4",
    "1571": "3:4",
    "1572": "4:4",
    "1573": "0:5",
    "1574": "1:5",
    "1575": "2:5",
    "1576": "3:5",
    "1577": "0:6",
    "1578": "1:6",
    "1579": "2:6",
    "1580": "0:7",
    "1581": "1:7",
    "1582": "0:8",
    "name": "Correct score {!score}",
    "group": "all|score|regular_play"
  },
  "431": {
    "1584": "0:0",
    "1585": "1:0",
    "1586": "2:0",
    "1587": "3:0",
    "1588": "4:0",
    "1589": "5:0",
    "1590": "0:1",
    "1591": "1:1",
    "1592": "2:1",
    "1593": "3:1",
    "1594": "4:1",
    "1595": "5:1",
    "1596": "0:2",
    "1597": "1:2",
    "1598": "2:2",
    "1599": "3:2",
    "1600": "4:2",
    "1601": "5:2",
    "1602": "0:3",
    "1603": "1:3",
    "1604": "2:3",
    "1605": "3:3",
    "1606": "4:3",
    "1607": "5:3",
    "1608": "0:4",
    "1609": "1:4",
    "1610": "2:4",
    "1611": "3:4",
    "1612": "4:4",
    "1613": "5:4",
    "1614": "0:5",
    "1615": "1:5",
    "1616": "2:5",
    "1617": "3:5",
    "1618": "4:5",
    "1619": "5:5",
    "1620": "other",
    "name": "Correct score",
    "group": "all|score|regular_play"
  },
  "432": {
    "1621": "1st period",
    "1622": "2nd period",
    "1623": "3rd period",
    "1624": "equal",
    "name": "Highest scoring period",
    "group": "all|score|regular_play"
  },
  "433": {
    "1621": "1st period",
    "1622": "2nd period",
    "1623": "3rd period",
    "1624": "equal",
    "name": "{$competitor1} highest scoring period",
    "group": "all|score|regular_play"
  },
  "434": {
    "1621": "1st period",
    "1622": "2nd period",
    "1623": "3rd period",
    "1624": "equal",
    "name": "{$competitor2} highest scoring period",
    "group": "all|score|regular_play"
  },
  "435": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win all periods",
    "group": "all|score|regular_play"
  },
  "436": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win all periods",
    "group": "all|score|regular_play"
  },
  "437": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win any period",
    "group": "all|score|regular_play"
  },
  "438": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win any period",
    "group": "all|score|regular_play"
  },
  "439": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to score in all periods",
    "group": "all|score|regular_play"
  },
  "440": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to score in all periods",
    "group": "all|score|regular_play"
  },
  "441": {
    "74": "yes",
    "76": "no",
    "name": "All periods over {total}",
    "group": "all|score|regular_play"
  },
  "442": {
    "74": "yes",
    "76": "no",
    "name": "All periods under {total}",
    "group": "all|score|regular_play"
  },
  "443": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr} period - 1x2",
    "group": "all|score|period"
  },
  "444": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!periodnr} period - {!goalnr} goal",
    "group": "all|score|period"
  },
  "445": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!periodnr} period - handicap {hcp}",
    "group": "all|score|period"
  },
  "446": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!periodnr} period - Over/Under",
    "group": "all|score|period"
  },
  "447": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!periodnr} period - {$competitor1} Over/Under",
    "group": "all|score|period"
  },
  "448": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!periodnr} period - {$competitor2} Over/Under",
    "group": "all|score|period"
  },
  "452": {
    "74": "yes",
    "76": "no",
    "name": "{!periodnr} period - both teams to score",
    "group": "all|score|period"
  },
  "453": {
    "784": "none",
    "788": "only {$competitor1}",
    "790": "only {$competitor2}",
    "792": "both teams",
    "name": "{!periodnr} period - which team to score",
    "group": "all|score|period"
  },
  "454": {
    "74": "yes",
    "76": "no",
    "name": "{!periodnr} period - {$competitor1} clean sheet",
    "group": "all|score|period"
  },
  "455": {
    "74": "yes",
    "76": "no",
    "name": "{!periodnr} period - {$competitor2} clean sheet",
    "group": "all|score|period"
  },
  "456": {
    "1630": "0:0",
    "1631": "1:0",
    "1632": "2:0",
    "1633": "0:1",
    "1634": "1:1",
    "1635": "2:1",
    "1636": "0:2",
    "1637": "1:2",
    "1638": "2:2",
    "1639": "other",
    "name": "{!periodnr} period - correct score",
    "group": "all|score|period"
  },
  "457": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!periodnr} period - last team to score",
    "group": "all|score|period"
  },
  "458": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!periodnr} period - which team wins the rest",
    "group": "all|score|period"
  },
  "459": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!periodnr} period - draw no bet",
    "group": "all|score|period"
  },
  "460": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!periodnr} period - handicap",
    "group": "all|score|period"
  },
  "462": {
    "70": "odd",
    "72": "even",
    "name": "{!periodnr} period - odd/even",
    "group": "all|score|period"
  },
  "463": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "Overtime - double chance",
    "group": "all|score|ot"
  },
  "464": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Overtime - draw no bet",
    "group": "all|score|ot"
  },
  "465": {
    "776": "X",
    "778": "{$competitor2}",
    "name": "Overtime - {$competitor1} no bet",
    "group": "all|score|ot"
  },
  "466": {
    "780": "{$competitor1}",
    "782": "X",
    "name": "Overtime - {$competitor2} no bet",
    "group": "all|score|ot"
  },
  "467": {
    "1640": "{$competitor1} with try",
    "1641": "{$competitor1} with penalty",
    "1642": "{$competitor1} with drop goal",
    "1643": "{$competitor2} with try",
    "1644": "{$competitor2} with penalty",
    "1645": "{$competitor2} with drop goal",
    "name": "{!scorenr} scoring play",
    "group": "all|score|regular_play"
  },
  "472": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - race to {pointnr} points",
    "group": "all|score|1st_half"
  },
  "473": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Try 1x2",
    "group": "all|regular_play|tries"
  },
  "474": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "Try double chance",
    "group": "all|regular_play|tries"
  },
  "475": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Try draw no bet",
    "group": "all|regular_play|tries"
  },
  "476": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Try handicap {hcp}",
    "group": "all|regular_play|tries"
  },
  "477": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Try handicap",
    "group": "all|regular_play|tries"
  },
  "478": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under tries",
    "group": "all|regular_play|tries"
  },
  "479": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under tries",
    "group": "all|regular_play|tries"
  },
  "480": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under tries",
    "group": "all|regular_play|tries"
  },
  "481": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even tries",
    "group": "all|regular_play|tries"
  },
  "482": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT - try 1x2",
    "group": "all|1st_half|tries"
  },
  "483": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "1st HT - try double chance",
    "group": "all|1st_half|tries"
  },
  "484": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st HT - try draw no bet",
    "group": "all|1st_half|tries"
  },
  "485": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1st HT - try handicap {hcp}",
    "group": "all|1st_half|tries"
  },
  "486": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1st HT - try handicap",
    "group": "all|1st_half|tries"
  },
  "487": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - Over/Under tries",
    "group": "all|1st_half|tries"
  },
  "488": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor1} Over/Under tries",
    "group": "all|1st_half|tries"
  },
  "489": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1st HT - {$competitor2} Over/Under tries",
    "group": "all|1st_half|tries"
  },
  "490": {
    "70": "odd",
    "72": "even",
    "name": "1st HT - odd/even tries",
    "group": "all|1st_half|tries"
  },
  "491": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Which player wins the rest of the match",
    "group": "all|score|regular_play"
  },
  "492": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a deciding frame",
    "group": "all|score|regular_play"
  },
  "493": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Frame handicap",
    "group": "all|score|regular_play"
  },
  "494": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under frames",
    "group": "all|score|regular_play"
  },
  "495": {
    "70": "odd",
    "72": "even",
    "name": "Odd/even frames",
    "group": "all|score|regular_play"
  },
  "496": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to {framenr} frames",
    "group": "all|score|regular_play"
  },
  "497": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Frames {fromframe} to {toframe} - {frames} consecutive frames winner",
    "group": "all|score|x_frames"
  },
  "498": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Frames 1 to {framenr} - 1x2",
    "group": "all|score|x_frames"
  },
  "499": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} frame - winner",
    "group": "all|score|frame"
  },
  "500": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!framenr} frame - point handicap",
    "group": "all|score|frame"
  },
  "501": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!framenr} frame - Over/Under points",
    "group": "all|score|frame"
  },
  "502": {
    "70": "odd",
    "72": "even",
    "name": "{!framenr} frame - odd/even",
    "group": "all|score|frame"
  },
  "503": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} frame - race to {pointnr} points",
    "group": "all|score|frame"
  },
  "504": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} frame - player with highest break",
    "group": "all|frame|break"
  },
  "505": {
    "1667": "0-49",
    "1668": "50-99",
    "1669": "100-119",
    "1670": "120-146",
    "1671": "147+",
    "name": "{!framenr} frame - highest break",
    "group": "all|frame|break"
  },
  "506": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - break 100+",
    "group": "all|frame|break"
  },
  "507": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - {$competitor1} break 100+",
    "group": "all|frame|break"
  },
  "508": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - {$competitor2} break 100+",
    "group": "all|frame|break"
  },
  "509": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - break 50+",
    "group": "all|frame|break"
  },
  "510": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - {$competitor1} break 50+",
    "group": "all|frame|break"
  },
  "511": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - {$competitor2} break 50+",
    "group": "all|frame|break"
  },
  "512": {
    "74": "yes",
    "76": "no",
    "name": "{!framenr} frame - will there be a foul committed",
    "group": "all|score|frame"
  },
  "513": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} frame - player to pot {!xth} ball",
    "group": "all|score|frame"
  },
  "514": {
    "1672": "yellow",
    "1673": "green",
    "1674": "brown",
    "1675": "blue",
    "1676": "pink",
    "1677": "black",
    "name": "{!framenr} frame - {!xth} colour potted",
    "group": "all|score|frame"
  },
  "515": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} frame - player to pot last ball",
    "group": "all|score|frame"
  },
  "516": {
    "1678": "red",
    "1679": "yellow",
    "1680": "green",
    "1681": "brown",
    "1682": "blue",
    "1683": "pink",
    "1684": "black",
    "1685": "foul",
    "name": "{!framenr} frame - last points scored",
    "group": "all|score|frame"
  },
  "520": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} game - {!pointnr} point",
    "group": "all|score|game"
  },
  "525": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a 4th set",
    "group": "all|score|regular_play"
  },
  "526": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a 5th set",
    "group": "all|score|regular_play"
  },
  "527": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - handicap",
    "group": "all|score|set"
  },
  "528": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - Over/Under",
    "group": "all|score|set"
  },
  "529": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "{!periodnr} period - double chance",
    "group": "all|score|period"
  },
  "530": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - {!scorenr} score",
    "group": "all"
  },
  "538": {
    "1717": "X",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "540": {
    "1718": "{$competitor1}/X & yes",
    "1719": "{$competitor1}/X & no",
    "1720": "{$competitor1}/{$competitor2} & yes",
    "1721": "{$competitor1}/{$competitor2} & no",
    "1722": "X/{$competitor2} & yes",
    "1723": "X/{$competitor2} & no",
    "name": "Double chance (match) & 1st HT both teams score",
    "group": "all|regular_play|combo"
  },
  "541": {
    "1718": "{$competitor1}/X & yes",
    "1719": "{$competitor1}/X & no",
    "1720": "{$competitor1}/{$competitor2} & yes",
    "1721": "{$competitor1}/{$competitor2} & no",
    "1722": "X/{$competitor2} & yes",
    "1723": "X/{$competitor2} & no",
    "name": "Double chance (match) & 2nd HT both teams score",
    "group": "all|regular_play|combo"
  },
  "542": {
    "1718": "{$competitor1}/X & yes",
    "1719": "{$competitor1}/X & no",
    "1720": "{$competitor1}/{$competitor2} & yes",
    "1721": "{$competitor1}/{$competitor2} & no",
    "1722": "X/{$competitor2} & yes",
    "1723": "X/{$competitor2} & no",
    "name": "1st HT - double chance & both teams to score",
    "group": "all|combo|1st_half"
  },
  "543": {
    "78": "{$competitor1} & yes",
    "80": "{$competitor1} & no",
    "82": "X & yes",
    "84": "X & no",
    "86": "{$competitor2} & yes",
    "88": "{$competitor2} & no",
    "name": "2nd HT - 1x2 & both teams to score",
    "group": "all|combo|2nd_half"
  },
  "544": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "2nd HT - 1x2 & Over/Under",
    "group": "all|combo|2nd_half"
  },
  "545": {
    "1718": "{$competitor1}/X & yes",
    "1719": "{$competitor1}/X & no",
    "1720": "{$competitor1}/{$competitor2} & yes",
    "1721": "{$competitor1}/{$competitor2} & no",
    "1722": "X/{$competitor2} & yes",
    "1723": "X/{$competitor2} & no",
    "name": "2nd HT - double chance & both teams to score",
    "group": "all|combo|2nd_half"
  },
  "546": {
    "1718": "{$competitor1}/X & yes",
    "1719": "{$competitor1}/X & no",
    "1720": "{$competitor1}/{$competitor2} & yes",
    "1721": "{$competitor1}/{$competitor2} & no",
    "1722": "X/{$competitor2} & yes",
    "1723": "X/{$competitor2} & no",
    "name": "Double chance & both teams to score",
    "group": "all|regular_play|combo"
  },
  "547": {
    "1724": "{$competitor1}/X & under {total}",
    "1725": "{$competitor1}/{$competitor2} & under {total}",
    "1726": "X/{$competitor2} & under {total}",
    "1727": "{$competitor1}/X & over {total}",
    "1728": "{$competitor1}/{$competitor2} & over {total}",
    "1729": "X/{$competitor2} & over {total}",
    "name": "Double chance & Over/Under",
    "group": "all|regular_play|combo"
  },
  "548": {
    "1730": "1-2",
    "1731": "1-3",
    "1732": "1-4",
    "1733": "1-5",
    "1734": "1-6",
    "1735": "2-3",
    "1736": "2-4",
    "1737": "2-5",
    "1738": "2-6",
    "1739": "3-4",
    "1740": "3-5",
    "1741": "3-6",
    "1742": "4-5",
    "1743": "4-6",
    "1744": "5-6",
    "1745": "7+",
    "1804": "no goal",
    "name": "Multigoals",
    "group": "all|score|regular_play"
  },
  "549": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "no goal",
    "name": "{$competitor1} multigoals",
    "group": "all|score|regular_play"
  },
  "550": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "no goal",
    "name": "{$competitor2} multigoals",
    "group": "all|score|regular_play"
  },
  "551": {
    "1750": "1:0, 2:0 or 3:0",
    "1751": "0:1, 0:2 or 0:3",
    "1752": "4:0, 5:0 or 6:0",
    "1753": "0:4, 0:5 or 0:6",
    "1754": "2:1, 3:1 or 4:1",
    "1755": "1:2, 1:3 or 1:4",
    "1756": "3:2, 4:2, 4:3 or 5:1",
    "1757": "2:3, 2:4, 3:4 or 1:5",
    "1758": "other homewin",
    "1759": "other awaywin",
    "1803": "X",
    "name": "Multiscores",
    "group": "all|score|regular_play"
  },
  "552": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "no goal",
    "name": "1st HT - multigoals",
    "group": "all|score|1st_half"
  },
  "553": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "no goal",
    "name": "2nd HT - multigoals",
    "group": "all|score|2nd_half"
  },
  "554": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - kill draw no bet",
    "group": "all|kills|map"
  },
  "555": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - kill handicap",
    "group": "all|kills|map"
  },
  "556": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} dragon",
    "group": "all|map|structures"
  },
  "557": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} baron",
    "group": "all|map|structures"
  },
  "558": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} inhibitor",
    "group": "all|map|structures"
  },
  "563": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Race to {pointnr} points",
    "group": "all|score|regular_play"
  },
  "565": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minutes - corner 1x2 from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "566": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "15 minutes - {!cornernr} corner from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "567": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "15 minutes - corner handicap from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "568": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "15 minutes - Over/Under corners from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "569": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "15 minutes - {$competitor1} Over/Under corners from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "570": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "15 minutes - {$competitor2} Over/Under corners from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "571": {
    "70": "odd",
    "72": "even",
    "name": "15 minutes - odd/even corners from {from} to {to}",
    "group": "all|15_min|corners"
  },
  "572": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minutes - corner 1x2 from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "573": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "10 minutes - {!cornernr} corner from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "574": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "10 minutes - corner handicap from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "575": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "10 minutes - Over/Under corners from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "576": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "10 minutes - {$competitor1} Over/Under corners from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "577": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "10 minutes - {$competitor2} Over/Under corners from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "578": {
    "70": "odd",
    "72": "even",
    "name": "10 minutes - odd/even corners from {from} to {to}",
    "group": "all|10_min|corners"
  },
  "579": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minutes - corner 1x2 from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "580": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "5 minutes - {!cornernr} corner from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "581": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "5 minutes - corner handicap from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "582": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "5 minutes - Over/Under corners from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "583": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "5 minutes - {$competitor1} Over/Under corners from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "584": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "5 minutes - {$competitor2} Over/Under corners from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "585": {
    "70": "odd",
    "72": "even",
    "name": "5 minutes - odd/even corners from {from} to {to}",
    "group": "all|5_min|corners"
  },
  "586": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "15 minutes - booking 1x2 from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "587": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "15 minutes - Over/Under bookings from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "588": {
    "74": "yes",
    "76": "no",
    "name": "15 minutes - sending off from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "589": {
    "74": "yes",
    "76": "no",
    "name": "15 minutes - {$competitor1} sending off from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "590": {
    "74": "yes",
    "76": "no",
    "name": "15 minutes - {$competitor2} sending off from {from} to {to}",
    "group": "all|15_min|bookings"
  },
  "591": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "10 minutes - booking 1x2 from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "592": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "10 minutes - Over/Under bookings from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "593": {
    "74": "yes",
    "76": "no",
    "name": "10 minutes - sending off from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "594": {
    "74": "yes",
    "76": "no",
    "name": "10 minutes - {$competitor1} sending off from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "595": {
    "74": "yes",
    "76": "no",
    "name": "10 minutes - {$competitor2} sending off from {from} to {to}",
    "group": "all|10_min|bookings"
  },
  "596": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "5 minutes - booking 1x2 from {from} to {to}",
    "group": "all|5_min|bookings"
  },
  "597": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "5 minutes - Over/Under bookings from {from} to {to}",
    "group": "all|5_min|bookings"
  },
  "598": {
    "74": "yes",
    "76": "no",
    "name": "5 minutes - sending off from {from} to {to}",
    "group": "all|5_min|bookings"
  },
  "599": {
    "74": "yes",
    "76": "no",
    "name": "5 minutes - {$competitor1} sending off from {from} to {to}",
    "group": "all|5_min|bookings"
  },
  "600": {
    "74": "yes",
    "76": "no",
    "name": "5 minutes - {$competitor2} sending off from {from} to {to}",
    "group": "all|5_min|bookings"
  },
  "601": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Race to {cornernr} corners",
    "group": "all|regular_play|corners"
  },
  "602": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - race to {cornernr} corners",
    "group": "all|1st_half|corners"
  },
  "603": {
    "1797": "high left",
    "1798": "low left",
    "1799": "high center",
    "1800": "low center",
    "1801": "high right",
    "1802": "low right",
    "name": "{!goalnr} goal - strike zone",
    "group": "all|misc"
  },
  "604": {
    "74": "yes",
    "76": "no",
    "name": "{!penaltynr} penalty scored",
    "group": "all|score|regular_play"
  },
  "605": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - Over/Under",
    "group": "all|score|innings"
  },
  "606": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under",
    "group": "all|score|innings"
  },
  "607": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under",
    "group": "all|score|innings"
  },
  "608": {
    "70": "odd",
    "72": "even",
    "name": "{!inningnr} innings - odd/even",
    "group": "all|score|innings"
  },
  "609": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team with highest scoring quarter",
    "group": "all|score|regular_play"
  },
  "610": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "611": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} quarter - 1x2 (incl. overtime)",
    "group": "all|score|quarter_incl_ot"
  },
  "612": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Draw no bet (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "613": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - draw no bet (incl. overtime)",
    "group": "all|score|quarter_incl_ot"
  },
  "614": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} quarter - handicap (incl. overtime)",
    "group": "all|score|quarter_incl_ot"
  },
  "615": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!quarternr} quarter - Over/Under (incl. overtime)",
    "group": "all|score|quarter_incl_ot"
  },
  "616": {
    "70": "odd",
    "72": "even",
    "name": "{$competitor1} odd/even (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "617": {
    "70": "odd",
    "72": "even",
    "name": "{$competitor2} odd/even (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "618": {
    "70": "odd",
    "72": "even",
    "name": "1st HT - {$competitor1} odd/even",
    "group": "all|score|1st_half"
  },
  "619": {
    "70": "odd",
    "72": "even",
    "name": "1st HT - {$competitor2} odd/even",
    "group": "all|score|1st_half"
  },
  "620": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - race to {roundnr} rounds",
    "group": "all|score|map"
  },
  "621": {
    "70": "odd",
    "72": "even",
    "name": "{!mapnr} map - odd/even rounds (incl. overtime)",
    "group": "all|score|map_incl_ot"
  },
  "622": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map - Over/Under headshots (incl. overtime)",
    "group": "all|map_incl_ot|kills"
  },
  "623": {
    "74": "yes",
    "76": "no",
    "name": "{!mapnr} map - will there be an ace (incl. overtime)",
    "group": "all|map_incl_ot|kills"
  },
  "626": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map round {roundnr} - Over/Under kills",
    "group": "all|kills|round"
  },
  "627": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map round {roundnr} - kill handicap",
    "group": "all|kills|round"
  },
  "628": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map round {roundnr} - {!killnr} kill",
    "group": "all|kills|round"
  },
  "629": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map round {roundnr} - {$competitor1} Over/Under kills",
    "group": "all|kills|round"
  },
  "630": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map round {roundnr} - {$competitor2} Over/Under kills",
    "group": "all|kills|round"
  },
  "631": {
    "74": "yes",
    "76": "no",
    "name": "{!mapnr} map round {roundnr} - bomb planted",
    "group": "all|round|bomb"
  },
  "632": {
    "74": "yes",
    "76": "no",
    "name": "{!mapnr} map round {roundnr} - bomb defused",
    "group": "all|round|bomb"
  },
  "634": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team with highest scoring half",
    "group": "all|score|regular_play"
  },
  "638": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} Over/Under",
    "group": "all"
  },
  "639": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under fours",
    "group": "all"
  },
  "640": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under sixes",
    "group": "all"
  },
  "641": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} dismissal",
    "group": "all"
  },
  "642": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} dismissal",
    "group": "all"
  },
  "643": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} Over/Under fours",
    "group": "all"
  },
  "644": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} Over/Under sixes",
    "group": "all"
  },
  "645": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} innings over {overnr} - 1x2",
    "group": "all"
  },
  "646": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Team with highest score at {!dismissalnr} dismissal",
    "group": "all"
  },
  "647": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most fours",
    "group": "all"
  },
  "648": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most sixes",
    "group": "all"
  },
  "649": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under dismissals",
    "group": "all"
  },
  "650": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under dismissals",
    "group": "all"
  },
  "651": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {%player} dismissal method",
    "group": "all"
  },
  "652": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} boundary",
    "group": "all"
  },
  "653": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} boundary",
    "group": "all"
  },
  "654": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under run outs",
    "group": "all"
  },
  "655": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under extras",
    "group": "all"
  },
  "656": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "{!inningnr} innings - {!dismissalnr} partnership 1x2",
    "group": "all"
  },
  "657": {
    "1821": "{%player1}",
    "1822": "{%player2}",
    "name": "{!inningnr} innings - {!dismissalnr} batter out",
    "group": "all"
  },
  "658": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under fours",
    "group": "all"
  },
  "659": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under fours",
    "group": "all"
  },
  "660": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under sixes",
    "group": "all"
  },
  "661": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under sixes",
    "group": "all"
  },
  "662": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {%player} to score {milestone}",
    "group": "all"
  },
  "663": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Over/Under dismissals",
    "group": "all"
  },
  "664": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Over/Under dismissals",
    "group": "all"
  },
  "665": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!daynr} day session {sessionnr} - Over/Under",
    "group": "all"
  },
  "666": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under extras",
    "group": "all"
  },
  "667": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under extras",
    "group": "all"
  },
  "668": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under run outs",
    "group": "all"
  },
  "669": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under run outs",
    "group": "all"
  },
  "670": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under in the highest scoring over",
    "group": "all"
  },
  "671": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under in the highest scoring over",
    "group": "all"
  },
  "680": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most extras",
    "group": "all"
  },
  "681": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most run outs",
    "group": "all"
  },
  "682": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under in the highest scoring over",
    "group": "all"
  },
  "686": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Batter head2head (1x2)",
    "group": "all"
  },
  "687": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Bowler head2head (1x2)",
    "group": "all"
  },
  "688": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "All-rounder head2head (1x2)",
    "group": "all"
  },
  "689": {
    "1818": "{%player1}",
    "1819": "X",
    "1820": "{%player2}",
    "name": "Keeper head2head (1x2)",
    "group": "all"
  },
  "690": {
    "70": "odd",
    "72": "even",
    "name": "{!inningnr} innings - {$competitor1} odd/even",
    "group": "all"
  },
  "691": {
    "70": "odd",
    "72": "even",
    "name": "{!inningnr} innings - {$competitor2} odd/even",
    "group": "all"
  },
  "692": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {$competitor1} to finish with a boundary",
    "group": "all"
  },
  "693": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {$competitor2} to finish with a boundary",
    "group": "all"
  },
  "694": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Which team wins the coin toss",
    "group": "all"
  },
  "695": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under ducks",
    "group": "all"
  },
  "696": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under wides",
    "group": "all"
  },
  "697": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under dismissals",
    "group": "all"
  },
  "698": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Team with top batter",
    "group": "all"
  },
  "699": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Team with top bowler",
    "group": "all"
  },
  "700": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - any player to score {milestone}",
    "group": "all"
  },
  "701": {
    "74": "yes",
    "76": "no",
    "name": "Any player to score {milestone}",
    "group": "all"
  },
  "702": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Top batter Over/Under",
    "group": "all"
  },
  "703": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Rabbit Over/Under",
    "group": "all"
  },
  "704": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under wides bowled",
    "group": "all"
  },
  "705": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under wides bowled",
    "group": "all"
  },
  "706": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under ducks",
    "group": "all"
  },
  "707": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under ducks",
    "group": "all"
  },
  "708": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} Over/Under dismissals",
    "group": "all"
  },
  "709": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under player performance",
    "group": "all"
  },
  "710": {
    "1813": "{$competitor1}",
    "1814": "neither",
    "1815": "{$competitor2}",
    "name": "Which team wins the coin toss and the match",
    "group": "all"
  },
  "711": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} innings - 1x2",
    "group": "all"
  },
  "712": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most keeper catches",
    "group": "all"
  },
  "713": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most catches",
    "group": "all"
  },
  "714": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most stumpings",
    "group": "all"
  },
  "717": {
    "1816": "{%player1} ({+hcp})",
    "1817": "{%player2} ({-hcp})",
    "name": "Batter head2head (handicap)",
    "group": "all"
  },
  "718": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {!dismissalnr} dismissal method (extended)",
    "group": "all"
  },
  "723": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a rampage",
    "group": "all|regular_play|kills"
  },
  "724": {
    "74": "yes",
    "76": "no",
    "name": "Will there be an ultra kill",
    "group": "all|regular_play|kills"
  },
  "725": {
    "1831": "00:00 - {(minute-1)}:59",
    "1832": "{minute}:00+",
    "name": "{!mapnr} map - duration",
    "group": "all|map|progress"
  },
  "726": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map - Over/Under kills",
    "group": "all|kills|map"
  },
  "727": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map - Over/Under aegis",
    "group": "all|map|structures"
  },
  "728": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map - Over/Under towers",
    "group": "all|map|structures"
  },
  "729": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - aegis handicap",
    "group": "all|map|structures"
  },
  "730": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - tower handicap",
    "group": "all|map|structures"
  },
  "731": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - race to {xth} kills",
    "group": "all|kills|map"
  },
  "732": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - race to {xth} net worth",
    "group": "all|map|progress"
  },
  "733": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - race to level {xth}",
    "group": "all|map|progress"
  },
  "734": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!mapnr} map 10 minutes - Over/Under kills from {from} to {to}",
    "group": "all|10_min|kills"
  },
  "736": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map 1st HT - winner",
    "group": "all|score|map_1st_half"
  },
  "737": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Maximum consecutive runs by either team",
    "group": "all|score|regular_play"
  },
  "738": {
    "1823": "top of 9th inning",
    "1824": "bottom of 9th inning",
    "1825": "any extra inning",
    "name": "When will the match be decided",
    "group": "all|score|regular_play"
  },
  "739": {
    "1826": "{!inningnr} inning",
    "1828": "{!(inningnr+1)} inning",
    "1829": "{!(inningnr+2)} inning",
    "1830": "other inning or no run",
    "name": "When will the {!runnr} run be scored (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "740": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under scoreless innings",
    "group": "all|score|regular_play"
  },
  "741": {
    "74": "yes",
    "76": "no",
    "name": "Both teams over {total} (incl. extra innings)",
    "group": "all|score|incl_ei"
  },
  "742": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "X & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & X",
    "1533": "X & X",
    "1534": "{$competitor2} & X",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "X & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "First {innings} innings 1x2 & 1x2 (incl. extra innings)",
    "group": "all|combo|incl_ei"
  },
  "743": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Innings {from} to {to} - 1x2",
    "group": "all|score|3_innings"
  },
  "744": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Innings {from} to {to} - handicap",
    "group": "all|score|3_innings"
  },
  "745": {
    "70": "odd",
    "72": "even",
    "name": "Innings {from} to {to} - odd/even",
    "group": "all|score|3_innings"
  },
  "746": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!inningnr} inning - handicap",
    "group": "all|score|inning"
  },
  "747": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor1} Over/Under",
    "group": "all|score|inning"
  },
  "748": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor2} Over/Under",
    "group": "all|score|inning"
  },
  "749": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} inning - {$competitor1} to score",
    "group": "all|score|inning"
  },
  "750": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} inning - {$competitor2} to score",
    "group": "all|score|inning"
  },
  "751": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} inning - both teams to score",
    "group": "all|score|inning"
  },
  "752": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} shrine",
    "group": "all|map|structures"
  },
  "753": {
    "9": "{$competitor1} or X",
    "10": "{$competitor1} or {$competitor2}",
    "11": "X or {$competitor2}",
    "name": "{!quarternr} quarter - double chance",
    "group": "all|score|quarter"
  },
  "754": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!quarternr} quarter - which team wins the rest",
    "group": "all|score|quarter"
  },
  "756": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!quarternr} quarter - {$competitor1} Over/Under",
    "group": "all|score|quarter"
  },
  "757": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!quarternr} quarter - {$competitor2} Over/Under",
    "group": "all|score|quarter"
  },
  "797": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - home teams Over/Under",
    "group": "all|matchday"
  },
  "798": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - away teams Over/Under",
    "group": "all|matchday"
  },
  "799": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - Over/Under",
    "group": "all|matchday"
  },
  "800": {
    "1833": "home teams",
    "1834": "X",
    "1835": "away teams",
    "name": "{$event} matchday {matchday} - most goals home or away teams",
    "group": "all|matchday"
  },
  "801": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - Over/Under home team wins",
    "group": "all|matchday"
  },
  "802": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - Over/Under draws",
    "group": "all|matchday"
  },
  "803": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$event} matchday {matchday} - Over/Under away team wins",
    "group": "all|matchday"
  },
  "815": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - assist draw no bet",
    "group": "all"
  },
  "816": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {$competitor1} {!dismissalnr} dismissal method (extended)",
    "group": "all"
  },
  "817": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {$competitor2} {!dismissalnr} dismissal method (extended)",
    "group": "all"
  },
  "818": {
    "1836": "{$competitor1}/{$competitor1} & under {total}",
    "1837": "{$competitor1}/X & under {total}",
    "1838": "{$competitor1}/{$competitor2} & under {total}",
    "1839": "X/{$competitor1} & under {total}",
    "1840": "X/X & under {total}",
    "1841": "X/{$competitor2} & under {total}",
    "1842": "{$competitor2}/{$competitor1} & under {total}",
    "1843": "{$competitor2}/X & under {total}",
    "1844": "{$competitor2}/{$competitor2} & under {total}",
    "1845": "{$competitor1}/{$competitor1} & over {total}",
    "1846": "{$competitor1}/X & over {total}",
    "1847": "{$competitor1}/{$competitor2} & over {total}",
    "1848": "X/{$competitor1} & over {total}",
    "1849": "X/X & over {total}",
    "1850": "X/{$competitor2} & over {total}",
    "1851": "{$competitor2}/{$competitor1} & over {total}",
    "1852": "{$competitor2}/X & over {total}",
    "1853": "{$competitor2}/{$competitor2} & over {total}",
    "name": "HT/fulltime & Over/Under",
    "group": "all|regular_play|combo"
  },
  "819": {
    "1836": "{$competitor1}/{$competitor1} & under {total}",
    "1837": "{$competitor1}/X & under {total}",
    "1838": "{$competitor1}/{$competitor2} & under {total}",
    "1839": "X/{$competitor1} & under {total}",
    "1840": "X/X & under {total}",
    "1841": "X/{$competitor2} & under {total}",
    "1842": "{$competitor2}/{$competitor1} & under {total}",
    "1843": "{$competitor2}/X & under {total}",
    "1844": "{$competitor2}/{$competitor2} & under {total}",
    "1845": "{$competitor1}/{$competitor1} & over {total}",
    "1846": "{$competitor1}/X & over {total}",
    "1847": "{$competitor1}/{$competitor2} & over {total}",
    "1848": "X/{$competitor1} & over {total}",
    "1849": "X/X & over {total}",
    "1850": "X/{$competitor2} & over {total}",
    "1851": "{$competitor2}/{$competitor1} & over {total}",
    "1852": "{$competitor2}/X & over {total}",
    "1853": "{$competitor2}/{$competitor2} & over {total}",
    "name": "HT/fulltime & 1st HT Over/Under",
    "group": "all|regular_play|combo"
  },
  "820": {
    "1854": "X/X & 0",
    "1855": "{$competitor1}/{$competitor1} & 1",
    "1856": "X/{$competitor1} & 1",
    "1857": "X/{$competitor2} & 1",
    "1858": "{$competitor2}/{$competitor2} & 1",
    "1859": "{$competitor1}/{$competitor1} & 2",
    "1860": "{$competitor1}/X & 2",
    "1861": "X/{$competitor1} & 2",
    "1862": "X/X & 2",
    "1863": "X/{$competitor2} & 2",
    "1864": "{$competitor2}/X & 2",
    "1865": "{$competitor2}/{$competitor2} & 2",
    "1866": "{$competitor1}/{$competitor1} & 3",
    "1867": "{$competitor1}/{$competitor2} & 3",
    "1868": "X/{$competitor1} & 3",
    "1869": "X/{$competitor2} & 3",
    "1870": "{$competitor2}/{$competitor1} & 3",
    "1871": "{$competitor2}/{$competitor2} & 3",
    "1872": "{$competitor1}/{$competitor1} & 4",
    "1873": "{$competitor1}/X & 4",
    "1874": "{$competitor1}/{$competitor2} & 4",
    "1875": "X/{$competitor1} & 4",
    "1876": "X/X & 4",
    "1877": "X/{$competitor2} & 4",
    "1878": "{$competitor2}/{$competitor1} & 4",
    "1879": "{$competitor2}/X & 4",
    "1880": "{$competitor2}/{$competitor2} & 4",
    "1881": "{$competitor1}/{$competitor1} & 5+",
    "1882": "{$competitor1}/X & 5+",
    "1883": "{$competitor1}/{$competitor2} & 5+",
    "1884": "X/{$competitor1} & 5+",
    "1885": "X/X & 5+",
    "1886": "X/{$competitor2} & 5+",
    "1887": "{$competitor2}/{$competitor1} & 5+",
    "1888": "{$competitor2}/X & 5+",
    "1889": "{$competitor2}/{$competitor2} & 5+",
    "name": "HT/fulltime & exact goals",
    "group": "all|regular_play|combo"
  },
  "821": {
    "70": "odd",
    "72": "even",
    "name": "Draw sum odd/even",
    "group": "all"
  },
  "822": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Draw sum Over/Under",
    "group": "all"
  },
  "824": {
    "70": "odd",
    "72": "even",
    "name": "Bonus ball odd/even",
    "group": "all"
  },
  "825": {
    "70": "odd",
    "72": "even",
    "name": "Bonus ball sum odd/even",
    "group": "all"
  },
  "826": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Bonus ball Over/Under",
    "group": "all"
  },
  "827": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Bonus ball sum Over/Under",
    "group": "all"
  },
  "828": {
    "74": "yes",
    "76": "no",
    "name": "Bonus ball single digit",
    "group": "all"
  },
  "829": {
    "74": "yes",
    "76": "no",
    "name": "Bonus ball equals any regular ball",
    "group": "all"
  },
  "831": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Draw sum Over/Under (incl. bonus ball)",
    "group": "all"
  },
  "835": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} windex",
    "group": "all"
  },
  "836": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} windex",
    "group": "all"
  },
  "837": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1}/{$competitor2} supremacy",
    "group": "all"
  },
  "838": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2}/{$competitor1} supremacy",
    "group": "all"
  },
  "839": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Over/Under spread",
    "group": "all"
  },
  "840": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Over/Under spread",
    "group": "all"
  },
  "841": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Over/Under spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "842": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Over/Under spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "843": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} Over/Under spread",
    "group": "all"
  },
  "844": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Over/Under spread",
    "group": "all"
  },
  "845": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Over/Under spread",
    "group": "all"
  },
  "846": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} Over/Under spread",
    "group": "all"
  },
  "847": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} Over/Under spread",
    "group": "all"
  },
  "850": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win exactly 1 set",
    "group": "all|score|regular_play"
  },
  "851": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win exactly 1 set",
    "group": "all|score|regular_play"
  },
  "852": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win exactly 2 sets",
    "group": "all|score|regular_play"
  },
  "853": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win exactly 2 sets",
    "group": "all|score|regular_play"
  },
  "854": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} or over {total}",
    "group": "all|regular_play|combo"
  },
  "855": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} or under {total}",
    "group": "all|regular_play|combo"
  },
  "856": {
    "74": "yes",
    "76": "no",
    "name": "X or over {total}",
    "group": "all|regular_play|combo"
  },
  "857": {
    "74": "yes",
    "76": "no",
    "name": "X or under {total}",
    "group": "all|regular_play|combo"
  },
  "858": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} or over {total}",
    "group": "all|regular_play|combo"
  },
  "859": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} or under {total}",
    "group": "all|regular_play|combo"
  },
  "860": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} or both teams to score",
    "group": "all|regular_play|combo"
  },
  "861": {
    "74": "yes",
    "76": "no",
    "name": "X or both teams to score",
    "group": "all|regular_play|combo"
  },
  "862": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} or both teams to score",
    "group": "all|regular_play|combo"
  },
  "863": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} or any clean sheet",
    "group": "all|regular_play|combo"
  },
  "864": {
    "74": "yes",
    "76": "no",
    "name": "X or any clean sheet",
    "group": "all|regular_play|combo"
  },
  "865": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} or any clean sheet",
    "group": "all|regular_play|combo"
  },
  "870": {
    "1893": "others",
    "name": "Exacta",
    "group": "all"
  },
  "871": {
    "1893": "others",
    "name": "Quinella",
    "group": "all"
  },
  "872": {
    "1893": "others",
    "name": "Trifecta",
    "group": "all"
  },
  "873": {
    "1893": "others",
    "name": "Trio",
    "group": "all"
  },
  "875": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under at {!dismissalnr} dismissal",
    "group": "all"
  },
  "876": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under at {!dismissalnr} dismissal",
    "group": "all"
  },
  "877": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor1} Over/Under",
    "group": "all"
  },
  "878": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {$competitor2} Over/Under",
    "group": "all"
  },
  "879": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win",
    "group": "all|score|regular_play"
  },
  "880": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win",
    "group": "all|score|regular_play"
  },
  "881": {
    "74": "yes",
    "76": "no",
    "name": "Any team to win",
    "group": "all|score|regular_play"
  },
  "882": {
    "74": "yes",
    "76": "no",
    "name": "{%player} to score (incl. overtime)",
    "group": "all|scorers|incl_ot"
  },
  "883": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1 minute - Over/Under from {from} to {to}",
    "group": "all|score|rapid_market"
  },
  "884": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1 minute - Over/Under corners from {from} to {to}",
    "group": "all|corners|rapid_market"
  },
  "885": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1 minute - Over/Under bookings from {from} to {to}",
    "group": "all|bookings|rapid_market"
  },
  "886": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1 minute - Over/Under offsides from {from} to {to}",
    "group": "all|rapid_market|offsides"
  },
  "887": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "1 minute - Over/Under penalties awarded from {from} to {to}",
    "group": "all|rapid_market|penalties"
  },
  "888": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & X",
    "1896": "{%player} & {$competitor2}",
    "1897": "other",
    "name": "Anytime goalscorer & 1x2",
    "group": "all|regular_play|combo"
  },
  "889": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "other",
    "name": "Anytime goalscorer & correct score",
    "group": "all|regular_play|combo"
  },
  "890": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "other",
    "name": "{!goalnr} goalscorer & correct score",
    "group": "all|regular_play|combo"
  },
  "891": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & X",
    "1896": "{%player} & {$competitor2}",
    "1897": "other",
    "name": "{!goalnr} goalscorer & 1x2",
    "group": "all|regular_play|combo"
  },
  "894": {
    "1923": "7:0",
    "1924": "7:1",
    "1925": "7:2",
    "1926": "7:3",
    "1927": "7:4",
    "1928": "7:5",
    "1929": "other {$competitor1} win",
    "1930": "0:7",
    "1931": "1:7",
    "1932": "2:7",
    "1933": "3:7",
    "1934": "4:7",
    "1935": "5:7",
    "1936": "other {$competitor2} win",
    "name": "{!setnr} set tiebreak - correct score",
    "group": "all|score|tiebreak"
  },
  "895": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set tiebreak - Over/Under points",
    "group": "all|score|tiebreak"
  },
  "896": {
    "1937": "shot",
    "1938": "header",
    "1939": "own goal",
    "1940": "penalty",
    "1941": "free kick",
    "1942": "none",
    "name": "{!scorenr} scoring type",
    "group": "all|score|regular_play"
  },
  "897": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "other",
    "name": "Overtime - correct score",
    "group": "all|score|ot"
  },
  "900": {
    "1943": "{$competitor1} no goal",
    "name": "{$competitor1} {!c1goalnr} goalscorer",
    "group": "all|regular_play|scorers"
  },
  "901": {
    "1944": "{$competitor2} no goal",
    "name": "{$competitor2} {!c2goalnr} goalscorer",
    "group": "all|regular_play|scorers"
  },
  "902": {
    "1640": "{$competitor1} with try",
    "1641": "{$competitor1} with penalty",
    "1642": "{$competitor1} with drop goal",
    "1643": "{$competitor2} with try",
    "1644": "{$competitor2} with penalty",
    "1645": "{$competitor2} with drop goal",
    "name": "Next scoring play",
    "group": "all|score|regular_play"
  },
  "903": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Next score (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "904": {
    "1945": "touchdown",
    "1946": "field goal",
    "1947": "safety",
    "1948": "none",
    "name": "Next scoring type (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "905": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "1st HT - next score",
    "group": "all|score|1st_half"
  },
  "909": {
    "1949": "{$competitor1} d/st player",
    "1950": "{$competitor1} other player",
    "1951": "{$competitor2} d/st player",
    "1952": "{$competitor2} other player",
    "name": "{!touchdownnr} touchdown scorer (incl. overtime)",
    "group": "all|scorers|incl_ot"
  },
  "911": {
    "74": "yes",
    "76": "no",
    "name": "Will the fight go the distance",
    "group": "all"
  },
  "914": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under passing yards (incl. overtime)",
    "group": "all"
  },
  "915": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under pass completions (incl. overtime)",
    "group": "all"
  },
  "916": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under passing touchdowns (incl. overtime)",
    "group": "all"
  },
  "917": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under carries (incl. overtime)",
    "group": "all"
  },
  "918": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under rushing yards (incl. overtime)",
    "group": "all"
  },
  "919": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under receiving yards (incl. overtime)",
    "group": "all"
  },
  "920": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under receptions (incl. overtime)",
    "group": "all"
  },
  "921": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under points (incl. overtime)",
    "group": "all|score|incl_ot|player_props"
  },
  "922": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under assists (incl. overtime)",
    "group": "all|incl_ot|player_props|assist"
  },
  "923": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under rebounds (incl. overtime)",
    "group": "all|incl_ot|player_props|rebound"
  },
  "924": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under 3-point field goals (incl. overtime)",
    "group": "all|score|incl_ot|player_props"
  },
  "925": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under pitcher strikeouts (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "926": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under bases (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "927": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under batter runs + runs batted in (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "928": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under earned runs (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "929": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under saves (incl. overtime)",
    "group": "all"
  },
  "931": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under touchdowns (incl. overtime)",
    "group": "all|incl_ot"
  },
  "932": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under field goals made (incl. overtime)",
    "group": "all|incl_ot"
  },
  "933": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under turnovers (incl. overtime)",
    "group": "all"
  },
  "934": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under sacks (incl. overtime)",
    "group": "all"
  },
  "940": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!fieldgoalnr} field goal made (incl. overtime)",
    "group": "all"
  },
  "956": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!timeoutnr} timeout",
    "group": "all"
  },
  "959": {
    "1961": "field goal attempt",
    "1962": "offensive touchdown",
    "1963": "punt",
    "1964": "turnover",
    "1965": "safety",
    "name": "{!drivenr} drive - result",
    "group": "all"
  },
  "960": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - last point",
    "group": "all"
  },
  "961": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!freethrownr} free throw scored",
    "group": "all"
  },
  "962": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under maximum consecutive points",
    "group": "all"
  },
  "963": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under maximum consecutive points",
    "group": "all"
  },
  "964": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Any team Over/Under maximum consecutive points",
    "group": "all"
  },
  "965": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to lead by {points}",
    "group": "all"
  },
  "966": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to lead by {points}",
    "group": "all"
  },
  "967": {
    "74": "yes",
    "76": "no",
    "name": "Any team to lead by {points}",
    "group": "all"
  },
  "970": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Over/Under sixes spread",
    "group": "all"
  },
  "971": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi sixes spread",
    "group": "all"
  },
  "972": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} 10/3 sixes head2head spread",
    "group": "all"
  },
  "973": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} 10/3 sixes head2head spread",
    "group": "all"
  },
  "974": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Over/Under sixes spread",
    "group": "all"
  },
  "975": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Over/Under sixes spread",
    "group": "all"
  },
  "976": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Over/Under fours spread",
    "group": "all"
  },
  "977": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi fours spread",
    "group": "all"
  },
  "978": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Over/Under fours spread",
    "group": "all"
  },
  "979": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Over/Under fours spread",
    "group": "all"
  },
  "980": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor1} joy of six spread",
    "group": "all"
  },
  "981": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{$competitor2} joy of six spread",
    "group": "all"
  },
  "982": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Over/Under {upsnr} ups spread",
    "group": "all"
  },
  "984": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} Over/Under {upsnr} ups spread",
    "group": "all"
  },
  "985": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} Over/Under {upsnr} ups spread",
    "group": "all"
  },
  "988": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} supremacy spread",
    "group": "all"
  },
  "989": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} supremacy spread",
    "group": "all"
  },
  "992": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Over/Under wides spread",
    "group": "all"
  },
  "993": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi wides spread",
    "group": "all"
  },
  "994": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings {!overnr} over - Over/Under runs spread",
    "group": "all"
  },
  "995": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Multi flyer spread",
    "group": "all"
  },
  "996": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Over/Under run outs spread",
    "group": "all"
  },
  "997": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Launch spread",
    "group": "all"
  },
  "998": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "Man of the match player performance spread",
    "group": "all"
  },
  "999": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{%player} Over/Under player performance spread",
    "group": "all"
  },
  "1000": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor1} multi run spread",
    "group": "all"
  },
  "1001": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor2} multi run spread",
    "group": "all"
  },
  "1002": {
    "1890": "sell",
    "1891": "buy",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} {upsnr} ups spread",
    "group": "all"
  },
  "1006": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "2 ball (1x2)",
    "group": "all"
  },
  "1007": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "2 ball (handicap)",
    "group": "all"
  },
  "1008": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under strokes",
    "group": "all"
  },
  "1010": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under eagles",
    "group": "all"
  },
  "1011": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under birdies",
    "group": "all"
  },
  "1012": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under pars",
    "group": "all"
  },
  "1013": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under bogeys",
    "group": "all"
  },
  "1014": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under 2+ over par",
    "group": "all"
  },
  "1016": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under eagles",
    "group": "all"
  },
  "1017": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under birdies",
    "group": "all"
  },
  "1018": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under pars",
    "group": "all"
  },
  "1019": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under bogeys",
    "group": "all"
  },
  "1020": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under 2+ over par",
    "group": "all"
  },
  "1021": {
    "70": "odd",
    "72": "even",
    "name": "{%competitor} odd/even strokes",
    "group": "all"
  },
  "1023": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - 2 ball (1x2)",
    "group": "all"
  },
  "1024": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole {holenr} - 2 ball (handicap)",
    "group": "all"
  },
  "1025": {
    "74": "yes",
    "76": "no",
    "name": "Hole {holenr} - any player under par",
    "group": "all"
  },
  "1026": {
    "74": "yes",
    "76": "no",
    "name": "Hole {holenr} - {%competitor} under par",
    "group": "all"
  },
  "1028": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2)",
    "group": "all"
  },
  "1029": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Holes {from} to {to} - 2 ball (handicap)",
    "group": "all"
  },
  "1030": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most birdies",
    "group": "all"
  },
  "1031": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most pars",
    "group": "all"
  },
  "1032": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most bogeys",
    "group": "all"
  },
  "1036": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "draw ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!quarternr} quarter - handicap {hcp}",
    "group": "all"
  },
  "1037": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Race to {goals} goals",
    "group": "all"
  },
  "1040": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1041": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1042": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under hits (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1043": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - Over/Under hits",
    "group": "all"
  },
  "1044": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor1} Over/Under hits",
    "group": "all"
  },
  "1045": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor2} Over/Under hits",
    "group": "all"
  },
  "1046": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - Over/Under hits",
    "group": "all"
  },
  "1047": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - {$competitor1} Over/Under hits",
    "group": "all"
  },
  "1048": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Innings 1 to 5 - {$competitor2} Over/Under hits",
    "group": "all"
  },
  "1049": {
    "1978": "strike",
    "1979": "ball",
    "1980": "hit",
    "1981": "other",
    "name": "Result of {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1050": {
    "74": "yes",
    "76": "no",
    "name": "Hit on {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1051": {
    "74": "yes",
    "76": "no",
    "name": "Home run on {!pitchnr} pitch",
    "group": "all|rapid_market|pitch"
  },
  "1052": {
    "1982": "single",
    "1983": "double",
    "1984": "triple",
    "1985": "home run",
    "1986": "no further hit",
    "name": "Result of {!hitnr} hit",
    "group": "all|rapid_market|hit"
  },
  "1053": {
    "1987": "on base",
    "1988": "out",
    "1989": "home run",
    "name": "Result of {%player} {!appearancenr} time at bat",
    "group": "all|player|rapid_market"
  },
  "1054": {
    "74": "yes",
    "76": "no",
    "name": "{%player} to strike out {!appearancenr} time at bat",
    "group": "all|player|rapid_market"
  },
  "1055": {
    "973": "{$competitor1} & over {total}",
    "974": "{$competitor2} & over {total}",
    "975": "{$competitor1} & under {total}",
    "976": "{$competitor2} & under {total}",
    "name": "Winner & Over/Under",
    "group": "all|regular_play|combo"
  },
  "1056": {
    "973": "{$competitor1} & over {total}",
    "974": "{$competitor2} & over {total}",
    "975": "{$competitor1} & under {total}",
    "976": "{$competitor2} & under {total}",
    "name": "{!setnr} set - winner & Over/Under",
    "group": "all|combo|set"
  },
  "1057": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!quarternr} quarter - race to {pointnr} points",
    "group": "all|score|quarter"
  },
  "1061": {
    "1990": "rush",
    "1991": "pass",
    "name": "{!drivenr} drive play {playnr} - {%competitor} play type",
    "group": "all|drive"
  },
  "1062": {
    "74": "yes",
    "76": "no",
    "name": "{!drivenr} drive play {playnr} - {%competitor} pass completion",
    "group": "all|drive"
  },
  "1063": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!drivenr} drive play {playnr} - {%competitor} Over/Under yards gained",
    "group": "all|drive"
  },
  "1064": {
    "74": "yes",
    "76": "no",
    "name": "{!drivenr} drive play {playnr} - {%competitor} new first down",
    "group": "all|drive"
  },
  "1065": {
    "74": "yes",
    "76": "no",
    "name": "{!drivenr} drive play {playnr} - {%competitor} sack",
    "group": "all|drive"
  },
  "1066": {
    "1992": "punt",
    "1993": "touchdown",
    "1994": "field goal attempt",
    "1995": "other",
    "name": "{!drivenr} drive - {%competitor} result",
    "group": "all|drive"
  },
  "1067": {
    "973": "{$competitor1} & over {total}",
    "974": "{$competitor2} & over {total}",
    "975": "{$competitor1} & under {total}",
    "976": "{$competitor2} & under {total}",
    "name": "Winner & Over/Under (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1068": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a grand slam (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1069": {
    "74": "yes",
    "76": "no",
    "name": "Any team win to nil (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1070": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most strikes",
    "group": "all"
  },
  "1071": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most balls",
    "group": "all"
  },
  "1072": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!inningnr} inning - most hits",
    "group": "all"
  },
  "1073": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - exact home runs",
    "group": "all"
  },
  "1074": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - {$competitor1} exact home runs",
    "group": "all"
  },
  "1075": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} inning - {$competitor2} exact home runs",
    "group": "all"
  },
  "1076": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - Over/Under pitches",
    "group": "all"
  },
  "1077": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor1} Over/Under pitches",
    "group": "all"
  },
  "1078": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} inning - {$competitor2} Over/Under pitches",
    "group": "all"
  },
  "1079": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} inning - {$competitor1} exact strikeouts",
    "group": "all"
  },
  "1080": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} inning - {$competitor2} exact strikeouts",
    "group": "all"
  },
  "1081": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} inning - {$competitor1} to record a double or triple play",
    "group": "all"
  },
  "1082": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} inning - {$competitor2} to record a double or triple play",
    "group": "all"
  },
  "1083": {
    "2005": "1-3",
    "2006": "4-5",
    "2007": "6+",
    "name": "Pitch range of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1084": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "Exact strikes of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1085": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "Exact balls of {%player} {!appearancenr} time at bat",
    "group": "all"
  },
  "1086": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under speed of {!pitchnr} pitch",
    "group": "all"
  },
  "1087": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Exact home runs (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "1088": {
    "2008": "{$competitor1} 1 point score",
    "2009": "{$competitor1} 2 point score",
    "2010": "{$competitor1} 3 point score",
    "2011": "{$competitor2} 1 point score",
    "2012": "{$competitor2} 2 point score",
    "2013": "{$competitor2} 3 point score",
    "name": "Scoring type {!pointnr} point (incl. overtime)",
    "group": "all"
  },
  "1089": {
    "2014": "1 point score",
    "2015": "2 point score",
    "2016": "3 point score",
    "name": "Any team scoring type {!pointnr} point (incl. overtime)",
    "group": "all"
  },
  "1090": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {!pointnr} point",
    "group": "all"
  },
  "1096": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under laps at {!stopnr} pit stop",
    "group": "all"
  },
  "1097": {
    "2017": "1-2",
    "2018": "3-4",
    "2019": "5-6",
    "2020": "7-8",
    "2021": "9-10",
    "2022": "11+",
    "name": "Grid position range of the winner",
    "group": "all"
  },
  "1098": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under overtakings",
    "group": "all"
  },
  "1099": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under finishers",
    "group": "all"
  },
  "1100": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under overtakings",
    "group": "all"
  },
  "1106": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%team} Over/Under overtakings",
    "group": "all"
  },
  "1108": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!lapnr} lap - Over/Under retirements",
    "group": "all"
  },
  "1119": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Race to {pointnr} points",
    "group": "all"
  },
  "1120": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1121": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1122": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under home runs (incl. extra innings)",
    "group": "all|incl_ei|home_run"
  },
  "1123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!inningnr} inning - Winner",
    "group": "all|inning"
  },
  "1124": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Innings 1 to 5 - Winner",
    "group": "all|5_innings"
  },
  "1125": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {%player1} to score {milestone} & {%player2} over {total} dismissals",
    "group": "all"
  },
  "1127": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {%player1} to score {milestone1} & {%player2} to score {milestone2}",
    "group": "all"
  },
  "1128": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {%player1} & {%player2} to score {milestone} & {%player3} over {total} dismissals",
    "group": "all"
  },
  "1129": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player1} + {%player2} Over/Under",
    "group": "all"
  },
  "1130": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player1} + {%player2} + {%player3} Over/Under",
    "group": "all"
  },
  "1131": {
    "74": "yes",
    "76": "no",
    "name": "Both teams to score {milestone}",
    "group": "all"
  },
  "1132": {
    "74": "yes",
    "76": "no",
    "name": "{!inningsnr} innings over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor1} over {total}",
    "group": "all"
  },
  "1133": {
    "74": "yes",
    "76": "no",
    "name": "{!inningsnr} innings over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor2} over {total}",
    "group": "all"
  },
  "1134": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {%player1} & {%player2} dismissal method",
    "group": "all"
  },
  "1135": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Which team has the highest 1st partnership & 1st over & overs 0 to {overnr}",
    "group": "all"
  },
  "1136": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "other",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} exact runs",
    "group": "all"
  },
  "1137": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "other",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} exact runs",
    "group": "all"
  },
  "1138": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} to be a wicket",
    "group": "all"
  },
  "1139": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} to be a wicket",
    "group": "all"
  },
  "1140": {
    "1806": "fielder catch",
    "1807": "bowled",
    "1808": "keeper catch",
    "1809": "lbw",
    "1810": "run out",
    "1811": "stumped",
    "1812": "other",
    "name": "{!inningnr} innings - {%player1} or {%player2} dismissal method",
    "group": "all"
  },
  "1141": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} to hit a boundary",
    "group": "all"
  },
  "1142": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} over {total}",
    "group": "all"
  },
  "1143": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} to score a boundary four & a six",
    "group": "all"
  },
  "1144": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} to score a boundary four & a six",
    "group": "all"
  },
  "1145": {
    "74": "yes",
    "76": "no",
    "name": "{!inningnr} innings - {%player1} or {%player2} to survive a review",
    "group": "all"
  },
  "1146": {
    "2023": "{%player1}",
    "2024": "none",
    "2025": "{%player2}",
    "name": "{!inningnr} innings - race to {runs} runs",
    "group": "all"
  },
  "1147": {
    "74": "yes",
    "76": "no",
    "name": "{%player} to score {milestone} & take a wicket & a catch",
    "group": "all"
  },
  "1148": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!overnr} over - {$competitor1} Over/Under ({ballcount}-ball overs)",
    "group": "all"
  },
  "1149": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!overnr} over - {$competitor2} Over/Under ({ballcount}-ball overs)",
    "group": "all"
  },
  "1150": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Overs 0 to {overnr} - {$competitor1} Over/Under ({ballcount}-ball overs)",
    "group": "all"
  },
  "1151": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Overs 0 to {overnr} - {$competitor2} Over/Under ({ballcount}-ball overs)",
    "group": "all"
  },
  "1152": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under rushing touchdowns (incl. overtime)",
    "group": "all"
  },
  "1158": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "2 ball",
    "group": "all"
  },
  "1160": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Draw no bet",
    "group": "all"
  },
  "1161": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "1162": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole handicap",
    "group": "all"
  },
  "1163": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%competitor} Over/Under holes won",
    "group": "all"
  },
  "1165": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under holes played",
    "group": "all"
  },
  "1166": {
    "74": "yes",
    "76": "no",
    "name": "Will there be a tie",
    "group": "all"
  },
  "1168": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - head2head (1x2)",
    "group": "all"
  },
  "1169": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Hole {holenr} - draw no bet",
    "group": "all"
  },
  "1170": {
    "1966": "{%competitor1}",
    "1967": "X",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - head2head (1x2)",
    "group": "all"
  },
  "1171": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Holes {from} to {to} - draw no bet",
    "group": "all"
  },
  "1173": {
    "973": "{$competitor1} & over {total}",
    "974": "{$competitor2} & over {total}",
    "975": "{$competitor1} & under {total}",
    "976": "{$competitor2} & under {total}",
    "name": "Winner (including OT) & Over/Under (including OT)",
    "group": "all"
  },
  "1174": {
    "2035": "{$competitor1} ({+hcp}) & over {total}",
    "2036": "{$competitor1} ({+hcp}) & under {total}",
    "2037": "{$competitor2} ({-hcp}) & over {total}",
    "2038": "{$competitor2} ({-hcp}) & under {total}",
    "name": "Handicap (including OT) & Over/Under (including OT)",
    "group": "all|combo|incl_ot"
  },
  "1175": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "1st quarter 1x2 & 1st quarter Over/Under",
    "group": "all|combo|incl_ot"
  },
  "1176": {
    "2035": "{$competitor1} ({+hcp}) & over {total}",
    "2036": "{$competitor1} ({+hcp}) & under {total}",
    "2037": "{$competitor2} ({-hcp}) & over {total}",
    "2038": "{$competitor2} ({-hcp}) & under {total}",
    "name": "1st quarter handicap & 1st quarter Over/Under",
    "group": "all|combo|incl_ot"
  },
  "1177": {
    "794": "{$competitor1} & under {total}",
    "796": "{$competitor1} & over {total}",
    "798": "X & under {total}",
    "800": "X & over {total}",
    "802": "{$competitor2} & under {total}",
    "804": "{$competitor2} & over {total}",
    "name": "1st HT 1x2 & 1st HT Over/Under",
    "group": "all|combo|incl_ot"
  },
  "1178": {
    "2035": "{$competitor1} ({+hcp}) & over {total}",
    "2036": "{$competitor1} ({+hcp}) & under {total}",
    "2037": "{$competitor2} ({-hcp}) & over {total}",
    "2038": "{$competitor2} ({-hcp}) & under {total}",
    "name": "1st HT handicap & 1st HT Over/Under",
    "group": "all|combo|incl_ot"
  },
  "1179": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1st HT Result or Match Result",
    "group": "all|regular_play"
  },
  "1183": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under shots (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1185": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under shots on goal (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1187": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under passes (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1189": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under tackles (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1193": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Highest scoring quarter - Over/Under",
    "group": "all|score|regular_play"
  },
  "1195": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Lowest scoring quarter - Over/Under",
    "group": "all|score|regular_play"
  },
  "1197": {
    "74": "yes",
    "76": "no",
    "name": "Any team to win both HT",
    "group": "all|score|regular_play"
  },
  "1199": {
    "74": "yes",
    "76": "no",
    "name": "Any team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1201": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Team to win both HT",
    "group": "all|score|regular_play"
  },
  "1203": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1207": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Next {!breaknr} break",
    "group": "all"
  },
  "1209": {
    "2039": "{$competitor1} 6-0, 6-1, 6-2",
    "2040": "{$competitor1} 6-3, 6-4",
    "2041": "{$competitor1} 7-5, 7-6",
    "2042": "{$competitor2} 6-0, 6-1, 6-2",
    "2043": "{$competitor2} 6-3, 6-4",
    "2044": "{$competitor2} 7-5, 7-6",
    "name": "{!setnr} set - exact score group",
    "group": "all"
  },
  "1211": {
    "74": "yes",
    "76": "no",
    "name": "Match to end {score}",
    "group": "all"
  },
  "1214": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} Over/Under deliveries faced",
    "group": "all"
  },
  "1215": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings - {%player} runs conceded",
    "group": "all"
  },
  "1218": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor1} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1219": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor2} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1220": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Over/Under batsman milestones (50s/100s)",
    "group": "all"
  },
  "1221": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{!inningnr} innings - {$competitor1} {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1222": {
    "1037": "caught",
    "1038": "not caught",
    "name": "{!inningnr} innings - {$competitor2} {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1229": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} Over/Under",
    "group": "all"
  },
  "1230": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} Over/Under",
    "group": "all"
  },
  "1231": {
    "74": "yes",
    "76": "no",
    "name": "Sum of bonus balls exact number",
    "group": "all"
  },
  "1242": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to home {homepoints} and away {awaypoints} points",
    "group": "all"
  },
  "1243": {
    "74": "yes",
    "76": "no",
    "name": "Anytime exact score {homepoints}:{awaypoints}",
    "group": "all"
  },
  "1244": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "King of the Oche (Match Treble)",
    "group": "all"
  },
  "1246": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Player with highest checkout",
    "group": "all"
  },
  "1248": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Highest checkout in match",
    "group": "all"
  },
  "1250": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under {points} + checkouts",
    "group": "all"
  },
  "1252": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Match winner & highest checkout",
    "group": "all"
  },
  "1254": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Match winner & most 180s",
    "group": "all"
  },
  "1256": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "Highest checkout & most 180s",
    "group": "all"
  },
  "1258": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "To lead after {!legnr} leg",
    "group": "all"
  },
  "1260": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!legnr} leg checkout Over/Under",
    "group": "all"
  },
  "1264": {
    "74": "yes",
    "76": "no",
    "name": "170 checkout in match",
    "group": "all"
  },
  "1269": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set game {gamenr} - ace",
    "group": "all|micro_market"
  },
  "1270": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!acenr} ace",
    "group": "all|micro_market"
  },
  "1271": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor1} Over/Under points",
    "group": "all|player_props"
  },
  "1272": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor2} Over/Under points",
    "group": "all|player_props"
  },
  "1273": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor2} Over/Under breaks",
    "group": "all|player_props"
  },
  "1274": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor1} Over/Under aces",
    "group": "all|player_props"
  },
  "1275": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor2} Over/Under aces",
    "group": "all|player_props"
  },
  "1276": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "{!setnr} set - most aces",
    "group": "all|player_props"
  },
  "1277": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set - {$competitor1} Over/Under breaks",
    "group": "all|player_props"
  },
  "1278": {
    "74": "yes",
    "76": "no",
    "name": "Both players to win a set",
    "group": "all|score|regular_play"
  },
  "1279": {
    "2047": "4:0",
    "2048": "3:1",
    "2049": "2:2",
    "2050": "1:3",
    "2051": "0:4",
    "name": "{!setnr} set - correct score after 4 games",
    "group": "all|score|set"
  },
  "1280": {
    "2052": "6:0",
    "2053": "5:1",
    "2054": "4:2",
    "2055": "3:3",
    "2056": "2:4",
    "2057": "1:5",
    "2058": "0:6",
    "name": "{!setnr} set - correct score after 6 games",
    "group": "all|score|set"
  },
  "1281": {
    "6": "{$competitor1}",
    "7": "none",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!breaknr} break",
    "group": "all|score|set|micro_market"
  },
  "1282": {
    "74": "yes",
    "76": "no",
    "name": "{!setnr} set game {gamenr} - break point",
    "group": "all|score|game|micro_market"
  },
  "1283": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Booking handicap",
    "group": "all|regular_play|bookings"
  },
  "1284": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Overtime 1st HT - Over/Under",
    "group": "all|score|ot_1st_half"
  },
  "1285": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under points",
    "group": "all|score|regular_play|player_props"
  },
  "1286": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under points",
    "group": "all|score|regular_play|player_props"
  },
  "1287": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1288": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1289": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1290": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1291": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Most aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1292": {
    "2059": "point after rally",
    "2060": "ace",
    "2061": "double fault",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point serve outcome",
    "group": "all|score|points|micro_market"
  },
  "1293": {
    "2064": "{$competitor1} winner",
    "2065": "{$competitor2} winner",
    "2066": "{$competitor1} error",
    "2067": "{$competitor2} error",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point outcome",
    "group": "all|score|points|micro_market"
  },
  "1294": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point Over/Under shots",
    "group": "all|score|points|micro_market"
  },
  "1295": {
    "2068": "serve",
    "2069": "return",
    "2070": "forehand",
    "2071": "backhand",
    "2072": "volley",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point last stroke",
    "group": "all|score|points|micro_market"
  },
  "1296": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under yellow cards",
    "group": "all|regular_play|bookings"
  },
  "1297": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Over/Under red cards",
    "group": "all|regular_play|bookings"
  },
  "1298": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "Yellow card 1x2",
    "group": "all|regular_play|bookings"
  },
  "1299": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Yellow card handicap",
    "group": "all|regular_play|bookings"
  },
  "1300": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under points (incl. overtime)",
    "group": "all"
  },
  "1301": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under assists (incl. overtime)",
    "group": "all"
  },
  "1302": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under rebounds (incl. overtime)",
    "group": "all"
  },
  "1303": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under 3-point field goals (incl. overtime)",
    "group": "all"
  },
  "1304": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{%player} Over/Under points + rebounds + assists (incl. overtime)",
    "group": "all|combo|incl_ot|player_props"
  },
  "1305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st HT - {points} point score draw no bet",
    "group": "all|score|1st_half|micro_market"
  },
  "1306": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd HT - {points} point score draw no bet",
    "group": "all|score|2nd_half|micro_market"
  },
  "1307": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {points} point score draw no bet",
    "group": "all|score|quarter|micro_market"
  },
  "1308": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1309": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1310": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1311": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1312": {
    "2073": "score",
    "2074": "no score",
    "name": "{!possessionnr} possession outcome",
    "group": "all|score|regular_play|micro_market"
  },
  "1313": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1314": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1315": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor1} Over/Under double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1316": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "{$competitor2} Over/Under double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1500": {
    "12": "over {total}",
    "13": "under {total}",
    "name": "Rest of Over/Under match",
    "group": "all"
  },
  "1601": {
    "16001": "{$competitor1} & 2-3 goals",
    "16002": "{$competitor1} & 2-4 goals",
    "16003": "{$competitor1} & 2-5 goals",
    "16004": "{$competitor1} & 3-4 goals",
    "16005": "{$competitor1} & 3-5 goals",
    "16006": "{$competitor1} & 3-6 goals",
    "16007": "X & 2-3 goals",
    "16008": "X & 2-4 goals",
    "16009": "X & 2-5 goals",
    "16010": "X & 3-4 goals",
    "16011": "X & 3-5 goals",
    "16012": "X & 3-6 goals",
    "16013": "{$competitor2} & 2-3 goals",
    "16014": "{$competitor2} & 2-4 goals",
    "16015": "{$competitor2} & 2-5 goals",
    "16016": "{$competitor2} & 3-4 goals",
    "16017": "{$competitor2} & 3-5 goals",
    "16018": "{$competitor2} & 3-6 goals",
    "name": "1x2 & Multigoals",
    "group": "all"
  },
  "1602": {
    "16021": "{$competitor1} or draw & 2-3 goals",
    "16022": "{$competitor1} or draw & 2-4 goals",
    "16023": "{$competitor1} or draw & 2-5 goals",
    "16024": "{$competitor1} or draw & 3-4 goals",
    "16025": "{$competitor1} or draw & 3-5 goals",
    "16026": "{$competitor1} or draw & 3-6 goals",
    "16027": "{$competitor1} or {$competitor2} & 2-3 goals",
    "16028": "{$competitor1} or {$competitor2} & 2-4 goals",
    "16029": "{$competitor1} or {$competitor2} & 2-5 goals",
    "16030": "{$competitor1} or {$competitor2} & 3-4 goals",
    "16031": "{$competitor1} or {$competitor2} & 3-5 goals",
    "16032": "{$competitor1} or {$competitor2} & 3-6 goals",
    "16033": "X or {$competitor2} & 2-3 goals",
    "16034": "X or {$competitor2} & 2-4 goals",
    "16035": "X or {$competitor2} & 2-5 goals",
    "16036": "X or {$competitor2} & 3-4 goals",
    "16037": "X or {$competitor2} & 3-5 goals",
    "16038": "X or {$competitor2} & 3-6 goals",
    "name": "Double chance & Multigoals",
    "group": "all"
  },
  "1603": {
    "16040": "0:0/1:1",
    "16041": "0:1/0:2/1:2",
    "16042": "0:3/1:3/2:3",
    "16043": "1:0/2:0/2:1",
    "16044": "1:4/2:4/3:4",
    "16045": "2:2/3:3/4:4",
    "16046": "3:0/3:1/3:2",
    "16047": "4:1/4:2/4:3",
    "16048": "4:0/0:4/Other",
    "name": "Multiscore-3",
    "group": "all"
  },
  "1604": {
    "16050": "0:0/1:1/0:1/1:0",
    "16051": "0:2/1:2/0:3/1:3",
    "16052": "0:4/1:4/2:4/3:4",
    "16053": "2:0/2:1/3:0/3:1",
    "16054": "2:2/2:3/3:2/3:3",
    "16055": "4:0/4:1/4:2/4:3",
    "16056": "4:4/Other",
    "name": "Multiscore-4",
    "group": "all"
  },
  "1605": {
    "16057": "{$competitor1} or no",
    "16058": "{$competitor1} or yes",
    "16059": "{$competitor2} or no",
    "16060": "{$competitor2} or yes",
    "16061": "X or no",
    "16062": "X or yes",
    "name": "1x2 or both teams to score",
    "group": "all"
  },
  "1606": {
    "16063": "{$competitor1}/X / {$competitor1}/X",
    "16064": "{$competitor1}/X / {$competitor1}/{$competitor2}",
    "16065": "{$competitor1}/X / X/{$competitor2}",
    "16066": "{$competitor1}/{$competitor2} / {$competitor1}/X",
    "16067": "{$competitor1}/{$competitor2} / X/{$competitor2}",
    "16068": "X/{$competitor2} / {$competitor1}/X",
    "16069": "{$competitor1}/{$competitor2} / {$competitor1}/{$competitor2}",
    "16070": "X/{$competitor2} / {$competitor1}/{$competitor2}",
    "16071": "X/{$competitor2} / X/{$competitor2}",
    "name": "Double chance HT/Fulltime",
    "group": "all"
  },
  "1607": {
    "16072": "{$competitor1} or {total} over",
    "16073": "X or {total} over",
    "16074": "{$competitor2} or {total} over",
    "16075": "{$competitor1} or {total} under",
    "16076": "X or {total} under",
    "16077": "{$competitor2} or {total} under",
    "name": "1x2 or {total} Over/Under",
    "group": "all"
  },
  "1608": {
    "16078": "yes or {total} over",
    "16079": "yes or {total} under",
    "16080": "no or {total} over",
    "16081": "no or {total} under",
    "name": "Both team to score or {total} Over/Under",
    "group": "all"
  },
  "1609": {
    "16082": "{$competitor1} and yes and {total} over",
    "16083": "{$competitor1} and no and {total} over",
    "16084": "{$competitor1} and no and {total} under",
    "16085": "draw and yes and {total} over",
    "16086": "draw and yes and {total} under",
    "16087": "draw and no and {total} under",
    "16088": "{$competitor2} and yes and {total} over",
    "16089": "{$competitor2} and no and {total} over",
    "16090": "{$competitor2} and no and {total} under",
    "name": "1x2 and Both team to score and {total} Over/Under",
    "group": "all"
  },
  "1610": {
    "16091": "<1 and <1",
    "16092": ">=1 and >=1",
    "16093": "<1 and <2",
    "16094": ">=1 and >=2",
    "16095": "<1 and <3",
    "16096": ">=1 and >=3",
    "16097": "<2 and <1",
    "16098": ">=2 and >=1",
    "16099": "<2 and <2",
    "16100": ">=2 and >=2",
    "16101": "<2 and <3",
    "16102": ">=2 and >=3",
    "16103": "<3 and <1",
    "16104": ">=3 and >=1",
    "16105": ">=3 and >=2",
    "16106": ">=3 and >=3",
    "name": "Exact goals in HT/2HT",
    "group": "all"
  },
  "1612": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 5 minutes",
    "group": "all"
  },
  "1613": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 10 minutes",
    "group": "all"
  },
  "1614": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 15 minutes",
    "group": "all"
  },
  "1615": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 20 minutes",
    "group": "all"
  },
  "1616": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 30 minutes",
    "group": "all"
  },
  "1617": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "1x2 in 60 minutes",
    "group": "all"
  },
  "1618": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 5 min",
    "group": "all"
  },
  "1619": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 10 min",
    "group": "all"
  },
  "1620": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 15 min",
    "group": "all"
  },
  "1621": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 20 min",
    "group": "all"
  },
  "1622": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 30 min",
    "group": "all"
  },
  "1623": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 60 min",
    "group": "all"
  },
  "1624": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 2 goals in a row",
    "group": "all"
  },
  "1625": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1626": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 2 goals in a row",
    "group": "all"
  },
  "1627": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 3 goals in a row",
    "group": "all"
  },
  "1628": {
    "74": "yes",
    "76": "no",
    "name": "Any 2 goals in a row",
    "group": "all"
  },
  "1629": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1630": {
    "74": "yes",
    "76": "no",
    "name": "Both team to score 2+",
    "group": "all"
  },
  "1631": {
    "1": "{$competitor1}",
    "2": "X",
    "3": "{$competitor2}",
    "name": "HT or fulltime",
    "group": "all"
  },
  "1632": {
    "1724": "{$competitor1}/X & under {total}",
    "1725": "{$competitor1}/{$competitor2} & under {total}",
    "1726": "X/{$competitor2} & under {total}",
    "1727": "{$competitor1}/X & over {total}",
    "1728": "{$competitor1}/{$competitor2} & over {total}",
    "1729": "X/{$competitor2} & over {total}",
    "name": "1st HT - Double chance and Over/Under HT or Fulltime",
    "group": "all"
  },
  "1633": {
    "16114": "{$competitor1}/X & {$competitor1}",
    "16115": "{$competitor1}/X & {$competitor2}",
    "16116": "{$competitor1}/X & X",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & X",
    "16120": "X/{$competitor2} & {$competitor1}",
    "16121": "X/{$competitor2} & {$competitor2}",
    "16122": "X/{$competitor2} & X",
    "name": "Double chance (1st HT) & 1x2",
    "group": "all"
  },
  "1634": {
    "16114": "{$competitor1}/X & {$competitor1}",
    "16115": "{$competitor1}/X & {$competitor2}",
    "16116": "{$competitor1}/X & X",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & X",
    "16120": "X/{$competitor2} & {$competitor1}",
    "16121": "X/{$competitor2} & {$competitor2}",
    "16122": "X/{$competitor2} & X",
    "name": "1x2 (1st HT) & Double chance",
    "group": "all"
  }
};

export const global_marketname = {
  7: "Remaining match", 8: "Next Goal", 18: "Over/Under", 19: "Home Total", 20: "Away Total", 1: "1x2", 10: "Double Chance",
  219: "12 Including Overtime", 225: "Under/Over Including Overtime", 251: "Winner", 258: "Under/Over Including Overtime", 340: "Winner", 186: "Winner"
};
